import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  /** The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID. */
  ID: string;
  /** The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text. */
  String: string;
  /** The `Boolean` scalar type represents `true` or `false`. */
  Boolean: boolean;
  /** The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1. */
  Int: number;
  /** The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point). */
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  Upload: any;
}

export interface Query {
  __typename?: 'Query';
  animal: SourceAnimal;
  animals: AnimalConnection;
  /** @deprecated Use animals instead. */
  getAnimals: AnimalConnection;
  animalType: AnimalType;
  /** @deprecated Use animalType instead. */
  AnimalType: AnimalType;
  animalTypes: Array<AnimalType>;
  /** @deprecated Use animalTypes instead. */
  AnimalTypes: Array<AnimalType>;
  randomName: RandomName;
  getAnimalsBySearchModule: ModuleSearchResult;
  searchSuggestions?: Maybe<Array<SearchSuggestion>>;
  getBreedSlug: BreedSlugResult;
  locations: Array<GeoLocation>;
  location: GeoLocation;
  launchDarklyDemo: LaunchDarklyDemoResponse;
  embed: EmbedInfo;
  upload: UploadInfo;
  /** @deprecated Use organizations instead. */
  getOrganizations: OrganizationConnection;
  organizations: OrganizationConnection;
  organizationTypes: Array<StringEnumerationOption>;
  /** sourceOrganization will prefer 'orgId' if both 'orgId' and 'displayId' are provided. orgId is required if retrieving from platform. */
  sourceOrganization?: Maybe<SourceOrganization>;
  userOrganizationContacts: Array<Maybe<OrganizationContact>>;
  organizationConfig: OrganizationConfig;
  locationConfig: LocationConfig;
  powerBIEmbedToken: PowerBiEmbedToken;
  /** annualReview2022 will prefer 'orgId' if both 'orgId' and 'displayId' are provided. */
  annualReview2022: AnnualReview2022;
  me?: Maybe<User>;
}


export interface QueryAnimalArgs {
  id: Scalars['ID'];
}


export interface QueryAnimalsArgs {
  ids: Array<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface QueryGetAnimalsArgs {
  ids: Array<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface QueryAnimalTypeArgs {
  typeId: Scalars['ID'];
}


export interface QueryAnimalTypeArgs {
  typeId: Scalars['ID'];
}


export interface QueryRandomNameArgs {
  gender: Gender;
}


export interface QueryGetAnimalsBySearchModuleArgs {
  modules: Array<SearchModule>;
  longitude: Scalars['String'];
  latitude: Scalars['String'];
  includedAnimalIds?: InputMaybe<Array<Scalars['Int']>>;
  excludedAnimalIds?: InputMaybe<Array<Scalars['Int']>>;
  organizationDisplayId?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  animalType?: InputMaybe<AnimalSearchAnimalType>;
  breedNameFilters?: InputMaybe<Array<Scalars['String']>>;
  allowUndercount?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}


export interface QuerySearchSuggestionsArgs {
  input?: InputMaybe<SearchSuggestionInput>;
}


export interface QueryGetBreedSlugArgs {
  breedId: Scalars['Int'];
}


export interface QueryLocationsArgs {
  q?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
}


export interface QueryLocationArgs {
  input?: InputMaybe<QueryLocationInput>;
}


export interface QueryEmbedArgs {
  embedUrl: Scalars['String'];
}


export interface QueryUploadArgs {
  uploadId: Scalars['ID'];
}


export interface QueryGetOrganizationsArgs {
  displayIds: Array<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface QueryOrganizationsArgs {
  displayIds: Array<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface QuerySourceOrganizationArgs {
  orgId?: InputMaybe<Scalars['ID']>;
  displayId?: InputMaybe<Scalars['ID']>;
}


export interface QueryUserOrganizationContactsArgs {
  userId: Scalars['ID'];
}


export interface QueryPowerBiEmbedTokenArgs {
  displayId?: InputMaybe<Scalars['ID']>;
  reportIds?: InputMaybe<Array<Scalars['String']>>;
  datasetIds?: InputMaybe<Array<Scalars['String']>>;
}


export interface QueryAnnualReview2022Args {
  orgId?: InputMaybe<Scalars['ID']>;
  displayId?: InputMaybe<Scalars['ID']>;
}

export interface SourceAnimal extends AbstractAnimal {
  __typename?: 'SourceAnimal';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  organizationLegacyId?: Maybe<Scalars['ID']>;
  locationLegacyId?: Maybe<Scalars['ID']>;
  contactLegacyId?: Maybe<Scalars['ID']>;
  /** @deprecated Use privateContact_ instead. */
  publicContact?: Maybe<Contact>;
  /** @deprecated Use type_.name instead. */
  type: Scalars['String'];
  type_?: Maybe<AnimalType>;
  /** @deprecated Use species_.name instead. */
  species?: Maybe<Scalars['String']>;
  species_?: Maybe<AnimalSpecies>;
  breeds: BreedInfo;
  colors: AnimalColor;
  age?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  coat?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  organizationAnimalId?: Maybe<Scalars['String']>;
  primaryPhotoUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use adoptionStatus_ instead. */
  adoptionStatus?: Maybe<Scalars['String']>;
  adoptionStatus_?: Maybe<AdoptionStatus>;
  adoptionStatusChanged?: Maybe<Scalars['DateTime']>;
  attributes?: Maybe<AnimalAttributes>;
  environment: AnimalEnvironment;
  tags: Array<Scalars['String']>;
  adoptionFee?: Maybe<Scalars['Float']>;
  adoptionFeeWaived?: Maybe<Scalars['Boolean']>;
  displayAdoptionFee?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use privateContact_.id instead. */
  privateContact?: Maybe<Scalars['String']>;
  /** @deprecated Use location.id instead. */
  locationId?: Maybe<Scalars['String']>;
  extendedDescription?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  arrival?: Maybe<Scalars['String']>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  adoptionDate?: Maybe<Scalars['DateTime']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  recordStatus?: Maybe<Scalars['String']>;
  specialNeeds?: Maybe<Scalars['String']>;
  organizationTransferredFrom?: Maybe<Scalars['String']>;
  transferDate?: Maybe<Scalars['DateTime']>;
  importUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  importDeletesEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validationErrors?: Maybe<Array<Maybe<AnimalValidationError>>>;
  statistics: AnimalStatistics;
  url?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['ID']>;
  /** Resolving changeHistory will make an additional HTTP request for each row in the result set. */
  changeHistory: Array<AnimalChangeHistory>;
  /** Resolving adoptionInquiries will make an additional HTTP request for each row in the result set. */
  adoptionInquiries: AdoptionInquiryConnection;
  /** @deprecated Use photos_.url instead. */
  photos: Array<Scalars['String']>;
  /** @deprecated Use type_.name instead. */
  typeName?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.primary instead. */
  primaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.secondary instead. */
  secondaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.mixed instead. */
  mixedBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use breeds.unknown instead. */
  unknownBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use adoptionStatus instead. */
  status?: Maybe<Scalars['String']>;
  photos_: Array<Maybe<AttachmentInfo>>;
  video?: Maybe<AttachmentInfo>;
  attachMedia: AttachMediaResponse;
  deleteAttachments: Array<DeleteAttachmentResponse>;
  location?: Maybe<LocationDetail>;
  organization?: Maybe<SourceOrganization>;
  /** Resolving privateContact will make an additional HTTP request for each row in the result set. */
  privateContact_?: Maybe<ContactDetail>;
}


export interface SourceAnimalStatisticsArgs {
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
}


export interface SourceAnimalAdoptionInquiriesArgs {
  input: AdoptionInquiryInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface SourceAnimalAttachMediaArgs {
  input: AttachMediaInput;
}


export interface SourceAnimalDeleteAttachmentsArgs {
  inputs: Array<DeleteAttachmentInput>;
}

export interface AbstractAnimal {
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  publicContact?: Maybe<Contact>;
  /** @deprecated Use typeName instead. */
  type: Scalars['String'];
  species?: Maybe<Scalars['String']>;
  breeds: BreedInfo;
  colors: AnimalColor;
  age?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  coat?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  organizationAnimalId?: Maybe<Scalars['String']>;
  primaryPhotoUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use adoptionStatus_ instead. */
  adoptionStatus?: Maybe<Scalars['String']>;
  adoptionStatus_?: Maybe<AdoptionStatus>;
  adoptionStatusChanged?: Maybe<Scalars['DateTime']>;
  attributes?: Maybe<AnimalAttributes>;
  environment: AnimalEnvironment;
  tags: Array<Scalars['String']>;
  adoptionFee?: Maybe<Scalars['Float']>;
  adoptionFeeWaived?: Maybe<Scalars['Boolean']>;
  displayAdoptionFee?: Maybe<Scalars['Boolean']>;
  statistics: AnimalStatistics;
  url?: Maybe<Scalars['String']>;
  changeHistory: Array<AnimalChangeHistory>;
  adoptionInquiries: AdoptionInquiryConnection;
  revision?: Maybe<Scalars['ID']>;
  /** @deprecated Use photos_.url instead. */
  photos: Array<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.primary instead. */
  primaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.secondary instead. */
  secondaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.mixed instead. */
  mixedBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use breeds.unknown instead. */
  unknownBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use adoptionStatus instead. */
  status?: Maybe<Scalars['String']>;
  photos_: Array<Maybe<AttachmentInfo>>;
  video?: Maybe<AttachmentInfo>;
  attachMedia: AttachMediaResponse;
  deleteAttachments: Array<DeleteAttachmentResponse>;
  organization?: Maybe<SourceOrganization>;
  /** Resolving privateContact will make an additional HTTP request for each row in the result set. */
  privateContact_?: Maybe<ContactDetail>;
}


export interface AbstractAnimalStatisticsArgs {
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
}


export interface AbstractAnimalAdoptionInquiriesArgs {
  input: AdoptionInquiryInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface AbstractAnimalAttachMediaArgs {
  input: AttachMediaInput;
}


export interface AbstractAnimalDeleteAttachmentsArgs {
  inputs: Array<DeleteAttachmentInput>;
}

export interface Contact {
  __typename?: 'Contact';
  id?: Maybe<Scalars['ID']>;
  /** firstName is not available on AbstractAnimal.publicContact. */
  firstName?: Maybe<Scalars['String']>;
  /** lastName is not available on AbstractAnimal.publicContact. */
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  address: ContactAddress;
}

export interface ContactAddress {
  __typename?: 'ContactAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  postcode: Scalars['String'];
  country: Scalars['String'];
}

export interface BreedInfo {
  __typename?: 'BreedInfo';
  primary?: Maybe<AnimalBreed>;
  secondary?: Maybe<AnimalBreed>;
  mixed?: Maybe<Scalars['Boolean']>;
  unknown?: Maybe<Scalars['Boolean']>;
}

export interface AnimalBreed {
  __typename?: 'AnimalBreed';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
}

export interface AnimalColor {
  __typename?: 'AnimalColor';
  primary?: Maybe<Scalars['String']>;
  secondary?: Maybe<Scalars['String']>;
  tertiary?: Maybe<Scalars['String']>;
}

export enum AdoptionStatus {
  ADOPTABLE = 'ADOPTABLE',
  ADOPTED = 'ADOPTED',
  FOUND = 'FOUND',
  HOLD = 'HOLD',
  OTHER = 'OTHER',
  PENDING = 'PENDING'
}

export interface AnimalAttributes {
  __typename?: 'AnimalAttributes';
  spayedNeutered: Scalars['Boolean'];
  houseTrained: Scalars['Boolean'];
  declawed?: Maybe<Scalars['Boolean']>;
  specialNeeds: Scalars['Boolean'];
  shotsCurrent: Scalars['Boolean'];
}

export interface AnimalEnvironment {
  __typename?: 'AnimalEnvironment';
  children?: Maybe<Scalars['Boolean']>;
  cats?: Maybe<Scalars['Boolean']>;
  dogs?: Maybe<Scalars['Boolean']>;
  otherAnimals?: Maybe<Scalars['Boolean']>;
  animals?: Maybe<Scalars['String']>;
}

export interface AnimalStatistics {
  __typename?: 'AnimalStatistics';
  views: AnimalStatistic;
  inquiries: AnimalStatistic;
}

export interface AnimalStatistic {
  __typename?: 'AnimalStatistic';
  total: Scalars['Int'];
  sum?: Maybe<Scalars['Int']>;
  days?: Maybe<Array<AnimalStatisticDay>>;
}

export interface AnimalStatisticDay {
  __typename?: 'AnimalStatisticDay';
  date: Scalars['String'];
  count: Scalars['Int'];
}

export interface AnimalChangeHistory {
  __typename?: 'AnimalChangeHistory';
  id: Scalars['ID'];
  type: AnimalChangeHistoryType;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['DateTime'];
  properties?: Maybe<Array<Scalars['String']>>;
  adoptionInquiryCount?: Maybe<Scalars['Int']>;
  adoptionStatus?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  oldOrgName?: Maybe<Scalars['String']>;
  newOrgName?: Maybe<Scalars['String']>;
}

export enum AnimalChangeHistoryType {
  DRAFT_CREATED = 'DRAFT_CREATED',
  DRAFT_MODIFIED = 'DRAFT_MODIFIED',
  CREATED_BY_IMPORT = 'CREATED_BY_IMPORT',
  ANIMAL_MODIFIED = 'ANIMAL_MODIFIED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  ADOPTION_INQUIRIES = 'ADOPTION_INQUIRIES',
  ANIMAL_TRANSFERRED = 'ANIMAL_TRANSFERRED',
  ANIMAL_DELETED = 'ANIMAL_DELETED',
  ANIMAL_UNDELETED = 'ANIMAL_UNDELETED'
}

export interface AdoptionInquiryInput {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
}

export interface AdoptionInquiryConnection {
  __typename?: 'AdoptionInquiryConnection';
  edges?: Maybe<Array<AdoptionInquiryEdge>>;
  nodes?: Maybe<Array<AdoptionInquiry>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface AdoptionInquiryEdge {
  __typename?: 'AdoptionInquiryEdge';
  cursor: Scalars['String'];
  node: AdoptionInquiry;
}

export interface AdoptionInquiry {
  __typename?: 'AdoptionInquiry';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
}

/**
 * Represents a page of organizations.
 * This follows [Relay's connection specification](https://relay.dev/graphql/connections.htm).
 */
export interface PageInfo {
  __typename?: 'PageInfo';
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
}

export interface AttachmentInfo {
  __typename?: 'AttachmentInfo';
  /** ID of relationship between Animal and Media. */
  attachmentId: Scalars['ID'];
  /** ID of underlying Media. null when type is EMBED. */
  mediaId?: Maybe<Scalars['ID']>;
  type: MediaType;
  url?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  embedCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
}

export enum MediaType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
  EMBED = 'EMBED'
}

export interface AttachMediaInput {
  mediaType: MediaType;
  /** The ID of the media to be attached. Required when mediaType is PHOTO or VIDEO. */
  mediaId?: InputMaybe<Scalars['ID']>;
  /** The embedCode for the video to be embedded. Required when mediaType is EMBED. */
  embedCode?: InputMaybe<Scalars['String']>;
  /** Index of photo to be attached. Only relevant when mediaType is PHOTO. */
  index?: InputMaybe<Scalars['Int']>;
  /** Image caption. Only valid when attaching to Organization. */
  caption?: InputMaybe<Scalars['String']>;
}

export type AttachMediaResponse = AttachmentInfo | UpstreamError;

export interface UpstreamError {
  __typename?: 'UpstreamError';
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
}

export interface DeleteAttachmentInput {
  attachmentType: MediaType;
  attachmentId: Scalars['ID'];
}

export type DeleteAttachmentResponse = DeletedAttachmentId | UpstreamError;

export interface DeletedAttachmentId {
  __typename?: 'DeletedAttachmentId';
  id: Scalars['ID'];
}

export interface SourceOrganization {
  __typename?: 'SourceOrganization';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  displayId: Scalars['String'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  otherTypeDetail?: Maybe<Scalars['String']>;
  directorName?: Maybe<Scalars['String']>;
  ein?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<ContactDetail>;
  primaryLocation?: Maybe<LocationDetail>;
  primaryPhoto?: Maybe<OrganizationPhoto>;
  mailingAddress?: Maybe<Address>;
  websiteUrl?: Maybe<Scalars['String']>;
  customUrlAlias?: Maybe<Scalars['String']>;
  missionStatement?: Maybe<Scalars['String']>;
  adoption?: Maybe<OrganizationAdoption>;
  locked: Scalars['Boolean'];
  lockReason?: Maybe<Scalars['String']>;
  deactivated: Scalars['Boolean'];
  deactivationReason?: Maybe<Scalars['String']>;
  apiExport: Scalars['Boolean'];
  partnerExport: Scalars['Boolean'];
  lastActive?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  socialMedia?: Maybe<SocialMedia>;
  publicUrl?: Maybe<Scalars['String']>;
  importStatistics: OrganizationImportStatistics;
  summaryStatistics: OrganizationSummaryStatistics;
  review: OrganizationReview;
  updateAccess: Success;
  contact_: AbstractContact;
  location_: AbstractLocation;
  contacts: ContactConnection;
  locations: LocationConnection;
  createContact: ContactDetail;
  createLocation: LocationDetail;
  deleteContact: ContactDetail;
  deleteLocation: LocationDetail;
  editContact: ContactDetail;
  editLocation: LocationDetail;
  inviteContact: ContactDetail;
  revision?: Maybe<Scalars['ID']>;
  animalTemplate: AnimalTemplate;
  animalTemplates: AnimalTemplateConnection;
  animals: AnimalConnection;
  createAnimalTemplate: AnimalTemplate;
  deleteAnimalTemplate?: Maybe<AnimalTemplate>;
  editAnimalTemplate: AnimalTemplate;
  primaryPhoto_?: Maybe<AttachmentInfo>;
  photos_: Array<Maybe<AttachmentInfo>>;
  attachMedia: AttachMediaResponse;
  deleteAttachments: Array<DeleteAttachmentResponse>;
}


export interface SourceOrganizationContactArgs {
  forcePrimary?: InputMaybe<Scalars['Boolean']>;
}


export interface SourceOrganizationLocationArgs {
  forcePrimary?: InputMaybe<Scalars['Boolean']>;
}


export interface SourceOrganizationContactsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface SourceOrganizationLocationsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface SourceOrganizationCreateContactArgs {
  input: ContactAddInput;
}


export interface SourceOrganizationCreateLocationArgs {
  input: LocationAddInput;
}


export interface SourceOrganizationDeleteContactArgs {
  contactId: Scalars['ID'];
}


export interface SourceOrganizationDeleteLocationArgs {
  locationId: Scalars['ID'];
}


export interface SourceOrganizationEditContactArgs {
  input: ContactEditInput;
}


export interface SourceOrganizationEditLocationArgs {
  input: LocationEditInput;
}


export interface SourceOrganizationInviteContactArgs {
  contactId: Scalars['ID'];
}


export interface SourceOrganizationAnimalTemplateArgs {
  templateId: Scalars['ID'];
}


export interface SourceOrganizationAnimalTemplatesArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  listInput?: InputMaybe<AnimalTemplateListInput>;
}


export interface SourceOrganizationAnimalsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<OrgAnimalSearchInput>;
}


export interface SourceOrganizationCreateAnimalTemplateArgs {
  input: CreateTemplateInput;
}


export interface SourceOrganizationDeleteAnimalTemplateArgs {
  templateId: Scalars['ID'];
}


export interface SourceOrganizationEditAnimalTemplateArgs {
  input: EditTemplateInput;
}


export interface SourceOrganizationAttachMediaArgs {
  input: AttachMediaInput;
}


export interface SourceOrganizationDeleteAttachmentsArgs {
  inputs: Array<DeleteAttachmentInput>;
}

export interface ContactDetail extends AbstractContact {
  __typename?: 'ContactDetail';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  linkedToUser: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  /** @deprecated Use role_ instead. */
  role: Scalars['String'];
  role_?: Maybe<Role>;
  isPrimary: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
}

export interface AbstractContact {
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
}

export interface Address {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
}

export enum Role {
  NOACCESS = 'NOACCESS',
  READONLY = 'READONLY',
  EDIT = 'EDIT',
  ADMIN = 'ADMIN'
}

export interface LocationDetail extends AbstractLocation {
  __typename?: 'LocationDetail';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  /** @deprecated Use type_ instead. */
  type: Scalars['String'];
  type_: LocationType;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  address: Address;
  isPrivate: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  contactName?: Maybe<Scalars['String']>;
  openToPublic?: Maybe<Scalars['Boolean']>;
  byAppointmentOnly?: Maybe<Scalars['Boolean']>;
  hours: Hours;
  isPrimary: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  isMapHidden?: Maybe<Scalars['Boolean']>;
}

export interface AbstractLocation {
  address?: Maybe<Address>;
  hours?: Maybe<Hours>;
}

export interface Hours {
  __typename?: 'Hours';
  monday?: Maybe<Scalars['String']>;
  tuesday?: Maybe<Scalars['String']>;
  wednesday?: Maybe<Scalars['String']>;
  thursday?: Maybe<Scalars['String']>;
  friday?: Maybe<Scalars['String']>;
  saturday?: Maybe<Scalars['String']>;
  sunday?: Maybe<Scalars['String']>;
}

export enum LocationType {
  FOSTER = 'FOSTER',
  SHELTER = 'SHELTER',
  ADOPTION = 'ADOPTION',
  BOARDING = 'BOARDING',
  GROOMING = 'GROOMING',
  HOSPITAL = 'HOSPITAL',
  OTHER = 'OTHER',
  DEFAULT = 'DEFAULT',
  TRANSPORT = 'TRANSPORT'
}

export interface OrganizationPhoto {
  __typename?: 'OrganizationPhoto';
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
}

export interface OrganizationAdoption {
  __typename?: 'OrganizationAdoption';
  policy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

export interface SocialMedia {
  __typename?: 'SocialMedia';
  facebook?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  pinterest?: Maybe<Scalars['String']>;
}

export interface OrganizationImportStatistics {
  __typename?: 'OrganizationImportStatistics';
  active: Scalars['Boolean'];
  configured: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
}

export interface OrganizationSummaryStatistics {
  __typename?: 'OrganizationSummaryStatistics';
  locationCount: Scalars['Int'];
  contactCount: Scalars['Int'];
  adoptableCount: Scalars['Int'];
  adoptedCount: Scalars['Int'];
  adoptionPendingCount: Scalars['Int'];
  holdCount: Scalars['Int'];
  foundCount: Scalars['Int'];
  otherCount: Scalars['Int'];
  draftCount: Scalars['Int'];
  publishedCount: Scalars['Int'];
  deletedCount: Scalars['Int'];
  archivedCount: Scalars['Int'];
  views: Scalars['Int'];
}

export interface OrganizationReview {
  __typename?: 'OrganizationReview';
  notifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedAt?: Maybe<Scalars['DateTime']>;
}

export interface Success {
  __typename?: 'Success';
  success: Scalars['Boolean'];
}

export interface ContactConnection {
  __typename?: 'ContactConnection';
  edges?: Maybe<Array<ContactEdge>>;
  nodes?: Maybe<Array<ContactDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface ContactEdge {
  __typename?: 'ContactEdge';
  cursor: Scalars['String'];
  node: ContactDetail;
}

export interface LocationConnection {
  __typename?: 'LocationConnection';
  edges?: Maybe<Array<LocationEdge>>;
  nodes?: Maybe<Array<LocationDetail>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface LocationEdge {
  __typename?: 'LocationEdge';
  cursor: Scalars['String'];
  node: LocationDetail;
}

export interface ContactAddInput {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  role: Role;
  inviteToConnectAccount?: InputMaybe<Scalars['Boolean']>;
}

export interface AddressInput {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postcode: Scalars['String'];
  country: Scalars['String'];
}

export interface LocationAddInput {
  name?: InputMaybe<Scalars['String']>;
  type: LocationType;
  /** 'email' is required if 'phone' is not provided */
  email?: InputMaybe<Scalars['String']>;
  /** 'phone' is required if 'email' is not provided */
  phone?: InputMaybe<Scalars['String']>;
  address: AddressInput;
  isPrivate: Scalars['Boolean'];
  contactName?: InputMaybe<Scalars['String']>;
  openToPublic?: InputMaybe<Scalars['Boolean']>;
  byAppointmentOnly?: InputMaybe<Scalars['Boolean']>;
  hours: HoursInput;
  isMapHidden?: InputMaybe<Scalars['Boolean']>;
}

export interface HoursInput {
  sunday: Scalars['String'];
  monday: Scalars['String'];
  tuesday: Scalars['String'];
  wednesday: Scalars['String'];
  thursday: Scalars['String'];
  friday: Scalars['String'];
  saturday: Scalars['String'];
}

export interface ContactEditInput {
  contactId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  role: Role;
}

export interface LocationEditInput {
  locationId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  type: LocationType;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  address: AddressInput;
  isPrivate: Scalars['Boolean'];
  contactName?: InputMaybe<Scalars['String']>;
  openToPublic?: InputMaybe<Scalars['Boolean']>;
  byAppointmentOnly?: InputMaybe<Scalars['Boolean']>;
  hours: HoursInput;
  isMapHidden?: InputMaybe<Scalars['Boolean']>;
}

export interface AnimalTemplate {
  __typename?: 'AnimalTemplate';
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  contact?: Maybe<Contact>;
  type: AnimalType;
  species?: Maybe<AnimalSpecies>;
  breeds?: Maybe<BreedInfo>;
  colors?: Maybe<AnimalColor>;
  age?: Maybe<Age>;
  gender?: Maybe<Gender>;
  size?: Maybe<Scalars['String']>;
  coatLength?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  arrival?: Maybe<Scalars['String']>;
  attributes?: Maybe<AnimalAttributes>;
  specialNeeds?: Maybe<Scalars['String']>;
  environment?: Maybe<AnimalEnvironment>;
  adoptionFee?: Maybe<Scalars['Float']>;
  adoptionFeeWaived?: Maybe<Scalars['Boolean']>;
  displayAdoptionFee?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<LocationDetail>;
}

export interface AnimalType {
  __typename?: 'AnimalType';
  id: Scalars['ID'];
  name: Scalars['String'];
  ages: Array<StringEnumerationOption>;
  arrivalOptions: Array<StringEnumerationOption>;
  attributes: Array<StringEnumerationOption>;
  coatLengths: Array<StringEnumerationOption>;
  colors: Array<StringEnumerationOption>;
  sexes: Array<StringEnumerationOption>;
  sizes: Array<AnimalSize>;
  statusOptions: Array<StringEnumerationOption>;
  species: Array<AnimalSpecies>;
}

export interface StringEnumerationOption {
  __typename?: 'StringEnumerationOption';
  label: Scalars['String'];
  value: Scalars['String'];
}

export interface AnimalSize {
  __typename?: 'AnimalSize';
  label: Scalars['String'];
  value: Scalars['String'];
  minWeight?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Int']>;
}

export interface AnimalSpecies {
  __typename?: 'AnimalSpecies';
  id: Scalars['ID'];
  name: Scalars['String'];
  breeds?: Maybe<Array<AnimalBreed>>;
}

export enum Age {
  BABY = 'BABY',
  YOUNG = 'YOUNG',
  ADULT = 'ADULT',
  SENIOR = 'SENIOR'
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN'
}

export interface AnimalTemplateListInput {
  sortField?: InputMaybe<TemplateSortField>;
  sortDir?: InputMaybe<SortDirection>;
  typeId?: InputMaybe<Scalars['ID']>;
}

export enum TemplateSortField {
  TITLE = 'TITLE',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED'
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface AnimalTemplateConnection {
  __typename?: 'AnimalTemplateConnection';
  edges?: Maybe<Array<AnimalTemplateEdge>>;
  nodes?: Maybe<Array<AnimalTemplate>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface AnimalTemplateEdge {
  __typename?: 'AnimalTemplateEdge';
  cursor: Scalars['String'];
  node: AnimalTemplate;
}

export interface OrgAnimalSearchInput {
  recordStatus?: InputMaybe<Array<RecordStatus>>;
  adoptionStatus?: InputMaybe<Array<AdoptionStatus>>;
  animalType?: InputMaybe<Array<Scalars['ID']>>;
  gender?: InputMaybe<Array<Gender>>;
  age?: InputMaybe<Array<Age>>;
  breed?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<OrgAnimalSortField>;
  sortDir?: InputMaybe<SortDirection>;
}

export enum RecordStatus {
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum OrgAnimalSortField {
  NAME = 'NAME',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED'
}

/**
 * Represents a page of animals.
 * This follows [Relay's connection specification](https://relay.dev/graphql/connections.htm).
 */
export interface AnimalConnection {
  __typename?: 'AnimalConnection';
  edges?: Maybe<Array<AnimalEdge>>;
  nodes?: Maybe<Array<AbstractAnimal>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface AnimalEdge {
  __typename?: 'AnimalEdge';
  cursor: Scalars['String'];
  node: AbstractAnimal;
}

export interface CreateTemplateInput {
  templateName: Scalars['String'];
  typeId: Scalars['ID'];
  attributes: AttributesInput;
  environment: EnvironmentInput;
  adoptionFeeWaived: Scalars['Boolean'];
  displayAdoptionFee: Scalars['Boolean'];
  animalSpeciesId?: InputMaybe<Scalars['ID']>;
  primaryBreedId?: InputMaybe<Scalars['ID']>;
  secondaryBreedId?: InputMaybe<Scalars['ID']>;
  isMixedBreed?: InputMaybe<Scalars['Boolean']>;
  isUnknownBreed?: InputMaybe<Scalars['Boolean']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  tertiaryColor?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  coatLength?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  specialNeedsNotes?: InputMaybe<Scalars['String']>;
  arrivalMethod?: InputMaybe<Scalars['String']>;
  adoptionFee?: InputMaybe<Scalars['Float']>;
  locationId?: InputMaybe<Scalars['ID']>;
  contactId?: InputMaybe<Scalars['ID']>;
}

export interface AttributesInput {
  spayedNeutered: Scalars['Boolean'];
  houseTrained: Scalars['Boolean'];
  declawed?: InputMaybe<Scalars['Boolean']>;
  specialNeeds: Scalars['Boolean'];
  shotsCurrent: Scalars['Boolean'];
}

export interface EnvironmentInput {
  goodWithChildren?: InputMaybe<Scalars['Boolean']>;
  goodWithDogs?: InputMaybe<Scalars['Boolean']>;
  goodWithCats?: InputMaybe<Scalars['Boolean']>;
  goodWithOtherAnimals?: InputMaybe<Scalars['Boolean']>;
  otherAnimals?: InputMaybe<Scalars['String']>;
}

export interface EditTemplateInput {
  templateId: Scalars['ID'];
  templateName: Scalars['String'];
  typeId: Scalars['ID'];
  attributes: AttributesInput;
  environment: EnvironmentInput;
  adoptionFeeWaived: Scalars['Boolean'];
  displayAdoptionFee: Scalars['Boolean'];
  animalSpeciesId?: InputMaybe<Scalars['ID']>;
  primaryBreedId?: InputMaybe<Scalars['ID']>;
  secondaryBreedId?: InputMaybe<Scalars['ID']>;
  isMixedBreed?: InputMaybe<Scalars['Boolean']>;
  isUnknownBreed?: InputMaybe<Scalars['Boolean']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  tertiaryColor?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  coatLength?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  specialNeedsNotes?: InputMaybe<Scalars['String']>;
  arrivalMethod?: InputMaybe<Scalars['String']>;
  adoptionFee?: InputMaybe<Scalars['Float']>;
  locationId?: InputMaybe<Scalars['ID']>;
  contactId?: InputMaybe<Scalars['ID']>;
}

export interface AnimalValidationError {
  __typename?: 'AnimalValidationError';
  error: Scalars['String'];
  field: Scalars['String'];
}

export interface RandomName {
  __typename?: 'RandomName';
  name: Scalars['String'];
}

export enum SearchModule {
  RECOMMENDED = 'RECOMMENDED',
  RECENT = 'RECENT',
  LIMITED_NEARBY = 'LIMITED_NEARBY',
  NEARBY = 'NEARBY',
  OTHER_FROM_ORGANIZATION = 'OTHER_FROM_ORGANIZATION'
}

export enum AnimalSearchAnimalType {
  DOG = 'DOG',
  CAT = 'CAT',
  RABBIT = 'RABBIT',
  SMALL_AND_FURRY = 'SMALL_AND_FURRY',
  SCALES_FINS_AND_OTHER = 'SCALES_FINS_AND_OTHER',
  BIRD = 'BIRD',
  HORSE = 'HORSE',
  BARNYARD = 'BARNYARD'
}

export interface ModuleSearchResult {
  __typename?: 'ModuleSearchResult';
  totalCount: Scalars['Int'];
  searchResults: Array<AnimalSearchResult>;
  matchedModule: SearchModule;
  callToActionUrl: Scalars['String'];
}

export interface AnimalSearchResult {
  __typename?: 'AnimalSearchResult';
  animal: AbstractAnimal;
  distance: Scalars['Float'];
  profileMatchScore?: Maybe<Scalars['Int']>;
  profileMatchType: MatchType;
}

export enum MatchType {
  GOOD_MATCH = 'GOOD_MATCH',
  BEST_MATCH = 'BEST_MATCH',
  NONE = 'NONE'
}

export interface SearchSuggestionInput {
  query?: InputMaybe<Scalars['String']>;
}

export interface SearchSuggestion {
  __typename?: 'SearchSuggestion';
  score: Scalars['Float'];
  animalType: AnimalSearchAnimalType;
  label: Scalars['String'];
  filter?: Maybe<SearchSuggestionFilter>;
  url: SearchUrl;
}

export interface SearchSuggestionFilter {
  __typename?: 'SearchSuggestionFilter';
  breed?: Maybe<Array<NameIdFilter>>;
  species?: Maybe<NameIdFilter>;
  age?: Maybe<Array<Age>>;
  size?: Maybe<Array<Size>>;
  gender?: Maybe<Array<Gender>>;
  color?: Maybe<Array<NameIdFilter>>;
  coatLength?: Maybe<Array<NameIdFilter>>;
  household?: Maybe<Array<GoodWith>>;
}

export interface NameIdFilter {
  __typename?: 'NameIdFilter';
  id: Scalars['Int'];
  name: Scalars['String'];
}

export enum Size {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  EXTRA_LARGE = 'EXTRA_LARGE'
}

export enum GoodWith {
  DOGS = 'DOGS',
  CATS = 'CATS',
  CHILDREN = 'CHILDREN'
}

export interface SearchUrl {
  __typename?: 'SearchUrl';
  path: Scalars['String'];
  query?: Maybe<Scalars['String']>;
}

export interface BreedSlugResult {
  __typename?: 'BreedSlugResult';
  slug?: Maybe<Scalars['String']>;
}

export interface GeoLocation {
  __typename?: 'GeoLocation';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  administrativeArea?: Maybe<Scalars['String']>;
  state: GeoCodeObject;
  postalCode?: Maybe<Scalars['String']>;
  country: GeoCodeObject;
  slug: Scalars['String'];
}

export interface GeoCodeObject {
  __typename?: 'GeoCodeObject';
  name: Scalars['String'];
  code: Scalars['String'];
}

export interface QueryLocationInput {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  locationSlug?: InputMaybe<Scalars['String']>;
}

export interface LaunchDarklyDemoResponse {
  __typename?: 'LaunchDarklyDemoResponse';
  targetApi?: Maybe<Scalars['String']>;
}

export interface EmbedInfo {
  __typename?: 'EmbedInfo';
  id: Scalars['ID'];
  embedCode: Scalars['String'];
  service: Scalars['String'];
  url: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
}

export interface UploadInfo {
  __typename?: 'UploadInfo';
  mediaId: Scalars['ID'];
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  s3uri?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  size: Scalars['Int'];
  checksum?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  parts: Array<UploadPart>;
}

export interface UploadPart {
  __typename?: 'UploadPart';
  part: Scalars['Int'];
  start: Scalars['Int'];
  end: Scalars['Int'];
  url: Scalars['String'];
  method: Scalars['String'];
}

export interface OrganizationConnection {
  __typename?: 'OrganizationConnection';
  edges?: Maybe<Array<OrganizationEdge>>;
  nodes?: Maybe<Array<IndexedOrganization>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface OrganizationEdge {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String'];
  node: IndexedOrganization;
}

export interface IndexedOrganization {
  __typename?: 'IndexedOrganization';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  displayId: Scalars['String'];
  name: Scalars['String'];
  /** @deprecated Use contact_ instead. */
  contact: ContactSummary;
  /**
   * Requesting forcePrimary = True will return ContactDetail of the primary contact
   * instead of ContactSummary at the expense of an additional CoreAPI call per row
   * in the result set.
   */
  contact_: AbstractContact;
  /** @deprecated Use location_ instead. */
  location: LocationSummary;
  /**
   * Requesting forcePrimary = True will return LocationDetail of the primary location
   * instead of a LocationSummary at the expense of an additional CoreAPI call per row
   * in the result set.
   */
  location_: AbstractLocation;
  website?: Maybe<Scalars['String']>;
  socialMedia: SocialMedia;
  missionStatement?: Maybe<Scalars['String']>;
  adoption: OrganizationAdoption;
  primaryPhoto: OrganizationPhoto;
  photos: Array<OrganizationPhoto>;
  importStatistics: OrganizationImportStatistics;
  summaryStatistics: OrganizationSummaryStatistics;
  updateAccess: Success;
  contacts: ContactConnection;
  locations: LocationConnection;
  createContact: ContactDetail;
  createLocation: LocationDetail;
  deleteContact: ContactDetail;
  deleteLocation: LocationDetail;
  editContact: ContactDetail;
  editLocation: LocationDetail;
  inviteContact: ContactDetail;
  publicUrl?: Maybe<Scalars['String']>;
  animalTemplate: AnimalTemplate;
  animalTemplates: AnimalTemplateConnection;
  animals: AnimalConnection;
  createAnimalTemplate: AnimalTemplate;
  deleteAnimalTemplate?: Maybe<AnimalTemplate>;
  editAnimalTemplate: AnimalTemplate;
  primaryPhoto_?: Maybe<AttachmentInfo>;
  photos_: Array<Maybe<AttachmentInfo>>;
  attachMedia: AttachMediaResponse;
  deleteAttachments: Array<DeleteAttachmentResponse>;
}


export interface IndexedOrganizationContactArgs {
  forcePrimary?: InputMaybe<Scalars['Boolean']>;
}


export interface IndexedOrganizationLocationArgs {
  forcePrimary?: InputMaybe<Scalars['Boolean']>;
}


export interface IndexedOrganizationContactsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface IndexedOrganizationLocationsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface IndexedOrganizationCreateContactArgs {
  input: ContactAddInput;
}


export interface IndexedOrganizationCreateLocationArgs {
  input: LocationAddInput;
}


export interface IndexedOrganizationDeleteContactArgs {
  contactId: Scalars['ID'];
}


export interface IndexedOrganizationDeleteLocationArgs {
  locationId: Scalars['ID'];
}


export interface IndexedOrganizationEditContactArgs {
  input: ContactEditInput;
}


export interface IndexedOrganizationEditLocationArgs {
  input: LocationEditInput;
}


export interface IndexedOrganizationInviteContactArgs {
  contactId: Scalars['ID'];
}


export interface IndexedOrganizationAnimalTemplateArgs {
  templateId: Scalars['ID'];
}


export interface IndexedOrganizationAnimalTemplatesArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  listInput?: InputMaybe<AnimalTemplateListInput>;
}


export interface IndexedOrganizationAnimalsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<OrgAnimalSearchInput>;
}


export interface IndexedOrganizationCreateAnimalTemplateArgs {
  input: CreateTemplateInput;
}


export interface IndexedOrganizationDeleteAnimalTemplateArgs {
  templateId: Scalars['ID'];
}


export interface IndexedOrganizationEditAnimalTemplateArgs {
  input: EditTemplateInput;
}


export interface IndexedOrganizationAttachMediaArgs {
  input: AttachMediaInput;
}


export interface IndexedOrganizationDeleteAttachmentsArgs {
  inputs: Array<DeleteAttachmentInput>;
}

export interface ContactSummary extends AbstractContact {
  __typename?: 'ContactSummary';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
}

export interface LocationSummary extends AbstractLocation {
  __typename?: 'LocationSummary';
  address?: Maybe<Address>;
  hours?: Maybe<Hours>;
}

export interface OrganizationContact {
  __typename?: 'OrganizationContact';
  userId: Scalars['ID'];
  contact: ContactDetail;
  organization: SourceOrganization;
}

export interface OrganizationConfig {
  __typename?: 'OrganizationConfig';
  organizationTypes: Array<StringEnumerationOption>;
  organizationRoles: RoleConnection;
  organizationPermissions: Array<StringEnumerationOption>;
}


export interface OrganizationConfigOrganizationRolesArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}

export interface RoleConnection {
  __typename?: 'RoleConnection';
  edges?: Maybe<Array<RoleEdge>>;
  nodes?: Maybe<Array<OrganizationRole>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface RoleEdge {
  __typename?: 'RoleEdge';
  cursor: Scalars['String'];
  node: OrganizationRole;
}

export interface OrganizationRole {
  __typename?: 'OrganizationRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}

export interface LocationConfig {
  __typename?: 'LocationConfig';
  countries: Array<StringEnumerationOption>;
  stateProvinces: Array<StringEnumerationOption>;
  locationTypes: Array<StringEnumerationOption>;
}


export interface LocationConfigStateProvincesArgs {
  countryCode: Scalars['String'];
}

export interface PowerBiEmbedToken {
  __typename?: 'PowerBIEmbedToken';
  tokenId?: Maybe<Scalars['ID']>;
  token: Scalars['String'];
  expiration: Scalars['DateTime'];
}

export interface AnnualReview2022 {
  __typename?: 'AnnualReview2022';
  organizationId?: Maybe<Scalars['Int']>;
  displayId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  totalPetsListed?: Maybe<Scalars['Int']>;
  totalPetViews?: Maybe<Scalars['Int']>;
  totalPetInquiries?: Maybe<Scalars['Int']>;
  totalPetsAdopted?: Maybe<Scalars['Int']>;
  totalPetsDeleted?: Maybe<Scalars['Int']>;
  averageTimeOnSite?: Maybe<Scalars['Float']>;
  mostFavoritedPets?: Maybe<Array<Maybe<TopAnimalData>>>;
  mostViewedPets?: Maybe<Array<Maybe<TopAnimalData>>>;
}

export interface TopAnimalData {
  __typename?: 'TopAnimalData';
  id?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  animal?: Maybe<Animal>;
}

export interface Animal {
  __typename?: 'Animal';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  publicContact?: Maybe<Contact>;
  /** @deprecated Use typeName instead. */
  type: Scalars['String'];
  species?: Maybe<Scalars['String']>;
  breeds: BreedInfo;
  colors: AnimalColor;
  age?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  coat?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  organizationAnimalId?: Maybe<Scalars['String']>;
  primaryPhotoUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use adoptionStatus_ instead. */
  adoptionStatus?: Maybe<Scalars['String']>;
  adoptionStatus_?: Maybe<AdoptionStatus>;
  adoptionStatusChanged?: Maybe<Scalars['DateTime']>;
  attributes?: Maybe<AnimalAttributes>;
  environment: AnimalEnvironment;
  tags: Array<Scalars['String']>;
  adoptionFee?: Maybe<Scalars['Float']>;
  adoptionFeeWaived?: Maybe<Scalars['Boolean']>;
  displayAdoptionFee?: Maybe<Scalars['Boolean']>;
  statistics: AnimalStatistics;
  url?: Maybe<Scalars['String']>;
  changeHistory: Array<AnimalChangeHistory>;
  adoptionInquiries: AdoptionInquiryConnection;
  revision?: Maybe<Scalars['ID']>;
  /** @deprecated Use photos_.url instead. */
  photos: Array<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.primary instead. */
  primaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.secondary instead. */
  secondaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.mixed instead. */
  mixedBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use breeds.unknown instead. */
  unknownBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use adoptionStatus instead. */
  status?: Maybe<Scalars['String']>;
}


export interface AnimalStatisticsArgs {
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
}


export interface AnimalAdoptionInquiriesArgs {
  input: AdoptionInquiryInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}

export interface User {
  __typename?: 'User';
  id: Scalars['ID'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  address: UserAddress;
  emailSubscriptions: Array<EmailSubscription>;
  profile: UserProfile;
  favorites: FavoriteConnection;
  userAnimalMatch?: Maybe<UserAnimalMatchPayload>;
  roles?: Maybe<Array<UserRole>>;
  savedSearches?: Maybe<Array<SavedSearch>>;
  platformAuthenticationToken?: Maybe<AuthenticationToken>;
  verifyPlatformAuthenticationToken?: Maybe<TokenData>;
}


export interface UserFavoritesArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFavorites>;
}


export interface UserUserAnimalMatchArgs {
  input: UserAnimalMatchInput;
}


export interface UserSavedSearchesArgs {
  sort: SavedSearchSort;
  sortOrder: SortOrder;
}


export interface UserVerifyPlatformAuthenticationTokenArgs {
  token: Scalars['String'];
}

export interface UserAddress {
  __typename?: 'UserAddress';
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode: Scalars['String'];
}

export interface EmailSubscription {
  __typename?: 'EmailSubscription';
  channel: SubscriptionChannel;
  active: Scalars['Boolean'];
}

export enum SubscriptionChannel {
  PETFINDER = 'PETFINDER',
  PURINA = 'PURINA',
  FOUNDATION = 'FOUNDATION',
  OTHER = 'OTHER'
}

export interface UserProfile {
  __typename?: 'UserProfile';
  animalSearchAnimalType?: Maybe<AnimalSearchAnimalType>;
  animalSearchCatAnimalAge?: Maybe<AnimalSearchAnimalAge>;
  animalSearchCatAnimalBehaviors?: Maybe<Array<AnimalSearchCatAnimalBehavior>>;
  /** @deprecated Use `animalSearchCatAnimalBreeds`. The new field will take precedent over this field if btoh are present when updating a user. */
  animalSearchCatAnimalBreed?: Maybe<Scalars['String']>;
  animalSearchCatAnimalBreeds?: Maybe<Array<Scalars['String']>>;
  animalSearchCatAnimalCoatLength?: Maybe<AnimalSearchAnimalCoatLength>;
  animalSearchCatAnimalGender?: Maybe<AnimalSearchAnimalGender>;
  animalSearchCatAnimalSize?: Maybe<AnimalSearchAnimalSize>;
  animalSearchCatAnimalSpecialNeeds?: Maybe<AnimalSearchAnimalSpecialNeeds>;
  animalSearchDogAnimalActivityLevel?: Maybe<AnimalSearchAnimalActivityLevel>;
  animalSearchDogAnimalAge?: Maybe<AnimalSearchAnimalAge>;
  animalSearchDogAnimalBehaviors?: Maybe<Array<AnimalSearchDogAnimalBehavior>>;
  /** @deprecated Use `animalSearchDogAnimalBreeds`. The new field will take precedent over this field if btoh are present when updating a user. */
  animalSearchDogAnimalBreed?: Maybe<Scalars['String']>;
  animalSearchDogAnimalBreeds?: Maybe<Array<Scalars['String']>>;
  animalSearchDogAnimalGender?: Maybe<AnimalSearchAnimalGender>;
  animalSearchDogAnimalSize?: Maybe<AnimalSearchAnimalSize>;
  animalSearchDogAnimalSpecialNeeds?: Maybe<AnimalSearchAnimalSpecialNeeds>;
  dogsInHome?: Maybe<QuantityInHome>;
  catsInHome?: Maybe<QuantityInHome>;
  childrenInHome?: Maybe<QuantityInHome>;
  petOwnershipAnimalType?: Maybe<PetOwnershipAnimalType>;
  petOwnershipType?: Maybe<PetOwnershipType>;
  /** @deprecated Use `userHomeChildrenChildren` and `userHomeChildrenAge`. The new fields will take precedent over this field if all are present when updating a user. */
  userHomeChildren?: Maybe<Array<UserHomeChildren>>;
  userHomeChildrenAge?: Maybe<UserHomeChildrenAge>;
  userHomeChildrenChildren?: Maybe<UserHomeChildrenChildren>;
  userHomeHoaDogRestrictions?: Maybe<UserHomeHoaDogRestrictions>;
  userHomeHoaDogRestrictionsBreeds?: Maybe<Array<Scalars['String']>>;
  userHomeHoaDogRestrictionsSize?: Maybe<UserHomeHoaDogRestrictionsSize>;
  userHomeNearbyAmenities?: Maybe<Array<UserHomeNearbyAmenity>>;
  userHomeType?: Maybe<UserHomeType>;
  userHomeYard?: Maybe<UserHomeYard>;
}

export enum AnimalSearchAnimalAge {
  NONE = 'NONE',
  BABY = 'BABY',
  YOUNG = 'YOUNG',
  ADULT = 'ADULT',
  SENIOR = 'SENIOR'
}

export enum AnimalSearchCatAnimalBehavior {
  NONE = 'NONE',
  ALLERGY_FRIENDLY = 'ALLERGY_FRIENDLY',
  LITTER_BOX_TRAINED = 'LITTER_BOX_TRAINED'
}

export enum AnimalSearchAnimalCoatLength {
  NONE = 'NONE',
  SHORT = 'SHORT',
  MEDIUM = 'MEDIUM',
  LONG = 'LONG'
}

export enum AnimalSearchAnimalGender {
  NONE = 'NONE',
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export enum AnimalSearchAnimalSize {
  NONE = 'NONE',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  EXTRA_LARGE = 'EXTRA_LARGE'
}

export enum AnimalSearchAnimalSpecialNeeds {
  YES = 'YES',
  NO = 'NO'
}

export enum AnimalSearchAnimalActivityLevel {
  NONE = 'NONE',
  VERY_ACTIVE = 'VERY_ACTIVE',
  ACTIVE = 'ACTIVE',
  LAID_BACK = 'LAID_BACK',
  LAP_PET = 'LAP_PET'
}

export enum AnimalSearchDogAnimalBehavior {
  NONE = 'NONE',
  ALLERGY_FRIENDLY = 'ALLERGY_FRIENDLY',
  HOUSE_TRAINED = 'HOUSE_TRAINED'
}

export enum QuantityInHome {
  ZERO = 'ZERO',
  ONE = 'ONE',
  TWO = 'TWO',
  THREE_PLUS = 'THREE_PLUS'
}

export enum PetOwnershipAnimalType {
  NONE = 'NONE',
  DOG = 'DOG',
  CAT = 'CAT',
  BOTH = 'BOTH'
}

export enum PetOwnershipType {
  FIRST_TIME = 'FIRST_TIME',
  PREVIOUS = 'PREVIOUS',
  CURRENT = 'CURRENT'
}

export enum UserHomeChildren {
  NONE = 'NONE',
  YOUNGER = 'YOUNGER',
  OLDER = 'OLDER'
}

export enum UserHomeChildrenAge {
  YOUNGER = 'YOUNGER',
  OLDER = 'OLDER',
  BOTH = 'BOTH'
}

export enum UserHomeChildrenChildren {
  YES = 'YES',
  NO = 'NO'
}

export enum UserHomeHoaDogRestrictions {
  YES = 'YES',
  NO = 'NO'
}

export enum UserHomeHoaDogRestrictionsSize {
  NONE = 'NONE',
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM'
}

export enum UserHomeNearbyAmenity {
  AREA = 'AREA',
  PARK = 'PARK'
}

export enum UserHomeType {
  SELF = 'SELF',
  FAMILY = 'FAMILY'
}

export enum UserHomeYard {
  NONE = 'NONE',
  FENCED = 'FENCED',
  YARD = 'YARD'
}

export enum SortFavorites {
  CREATED_ASC = 'CREATED_ASC',
  CREATED_DESC = 'CREATED_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  PUBLISHED_ASC = 'PUBLISHED_ASC',
  PUBLISHED_DESC = 'PUBLISHED_DESC'
}

/**
 * Represents a page of user's favorite animals.
 *
 * This follows [Relay's connection specification](https://relay.dev/graphql/connections.htm).
 */
export interface FavoriteConnection {
  __typename?: 'FavoriteConnection';
  edges?: Maybe<Array<FavoriteEdge>>;
  nodes?: Maybe<Array<Favorite>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
}

export interface FavoriteEdge {
  __typename?: 'FavoriteEdge';
  cursor: Scalars['String'];
  node: Favorite;
}

export interface Favorite {
  __typename?: 'Favorite';
  id: Scalars['ID'];
  inquired: Scalars['Boolean'];
  created: Scalars['DateTime'];
  animal?: Maybe<IndexedAnimal>;
}

export interface IndexedAnimal extends AbstractAnimal {
  __typename?: 'IndexedAnimal';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['ID']>;
  userMatchStrength?: Maybe<UserAnimalMatchStrength>;
  publicContact?: Maybe<Contact>;
  /** @deprecated Use typeName instead. */
  type: Scalars['String'];
  species?: Maybe<Scalars['String']>;
  breeds: BreedInfo;
  colors: AnimalColor;
  age?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  coat?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  organizationAnimalId?: Maybe<Scalars['String']>;
  primaryPhotoUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use adoptionStatus_ instead. */
  adoptionStatus?: Maybe<Scalars['String']>;
  adoptionStatus_?: Maybe<AdoptionStatus>;
  adoptionStatusChanged?: Maybe<Scalars['DateTime']>;
  attributes?: Maybe<AnimalAttributes>;
  environment: AnimalEnvironment;
  tags: Array<Scalars['String']>;
  adoptionFee?: Maybe<Scalars['Float']>;
  adoptionFeeWaived?: Maybe<Scalars['Boolean']>;
  displayAdoptionFee?: Maybe<Scalars['Boolean']>;
  distance?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  videoEmbed?: Maybe<Scalars['String']>;
  /** @deprecated Use photos_.url instead. */
  photoUrls: Array<Maybe<Scalars['String']>>;
  revision?: Maybe<Scalars['ID']>;
  /** Resolving adoptionInquiries will make an additional HTTP request for each row in the result set. */
  adoptionInquiries: AdoptionInquiryConnection;
  /** Resolving statistics will make an additional HTTP request for each row in the result set. */
  statistics: AnimalStatistics;
  /** Resolving changeHistory will make an additional HTTP request for each row in the result set. */
  changeHistory: Array<AnimalChangeHistory>;
  /** @deprecated Use photos_.url instead. */
  photos: Array<Scalars['String']>;
  typeName?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.primary instead. */
  primaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.secondary instead. */
  secondaryBreed?: Maybe<Scalars['String']>;
  /** @deprecated Use breeds.mixed instead. */
  mixedBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use breeds.unknown instead. */
  unknownBreed?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use publishedAt instead. */
  published?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use adoptionStatus instead. */
  status?: Maybe<Scalars['String']>;
  photos_: Array<Maybe<AttachmentInfo>>;
  video?: Maybe<AttachmentInfo>;
  attachMedia: AttachMediaResponse;
  deleteAttachments: Array<DeleteAttachmentResponse>;
  organization?: Maybe<SourceOrganization>;
  /** Resolving privateContact will make an additional HTTP request for each row in the result set. */
  privateContact_?: Maybe<ContactDetail>;
}


export interface IndexedAnimalAdoptionInquiriesArgs {
  input: AdoptionInquiryInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}


export interface IndexedAnimalStatisticsArgs {
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
}


export interface IndexedAnimalAttachMediaArgs {
  input: AttachMediaInput;
}


export interface IndexedAnimalDeleteAttachmentsArgs {
  inputs: Array<DeleteAttachmentInput>;
}

export enum UserAnimalMatchStrength {
  NONE = 'NONE',
  GOOD_MATCH = 'GOOD_MATCH',
  BEST_MATCH = 'BEST_MATCH'
}

export interface UserAnimalMatchInput {
  /** The ID of the animal to match to the user */
  animalId: Scalars['ID'];
}

export interface UserAnimalMatchPayload {
  __typename?: 'UserAnimalMatchPayload';
  matches?: Maybe<Array<UserAnimalMatch>>;
}

export interface UserAnimalMatch {
  __typename?: 'UserAnimalMatch';
  identifier: Scalars['String'];
  matchType: UserAnimalMatchType;
  user: Scalars['String'];
  animal?: Maybe<Scalars['String']>;
}

export enum UserAnimalMatchType {
  UNUSED_ANIMAL = 'UNUSED_ANIMAL',
  UNUSED_USER = 'UNUSED_USER',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  FLEXIBLE = 'FLEXIBLE'
}

export interface UserRole {
  __typename?: 'UserRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}

export enum SavedSearchSort {
  LAST_VIEW_DATE = 'LAST_VIEW_DATE',
  NEW_ANIMAL_COUNT = 'NEW_ANIMAL_COUNT',
  CREATED = 'CREATED'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface SavedSearch {
  __typename?: 'SavedSearch';
  id: Scalars['ID'];
  name: Scalars['String'];
  lastViewDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  newAnimalCount: Scalars['Int'];
  type?: Maybe<AnimalTypeEnum>;
  organizationDisplayIds?: Maybe<Array<Scalars['String']>>;
  query: SavedSearchQuery;
}

export enum AnimalTypeEnum {
  SMALL_FURRY = 'SMALL_FURRY',
  DOG = 'DOG',
  CAT = 'CAT',
  BIRD = 'BIRD',
  SCALE_FIN_OTHER = 'SCALE_FIN_OTHER',
  BARNYARD = 'BARNYARD',
  RABBIT = 'RABBIT',
  HORSE = 'HORSE'
}

export interface SavedSearchQuery {
  __typename?: 'SavedSearchQuery';
  location?: Maybe<SavedSearchQueryLocation>;
  type_id?: Maybe<Scalars['Int']>;
  species_id?: Maybe<Scalars['Int']>;
  adoption_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  breed_ids?: Maybe<Array<Scalars['String']>>;
  ages?: Maybe<Array<Scalars['String']>>;
  sexes?: Maybe<Array<Scalars['String']>>;
  sizes?: Maybe<Array<Scalars['String']>>;
  colors?: Maybe<Array<Scalars['String']>>;
  coat_lengths?: Maybe<Array<Scalars['String']>>;
  attributes?: Maybe<Array<Scalars['String']>>;
  behaviors?: Maybe<SavedSearchQueryBehaviors>;
  organization_display_ids?: Maybe<Array<Scalars['String']>>;
  animal_ids?: Maybe<Array<Scalars['Int']>>;
  published_before?: Maybe<Scalars['Int']>;
  published_after?: Maybe<Scalars['Int']>;
}

export interface SavedSearchQueryLocation {
  __typename?: 'SavedSearchQueryLocation';
  name: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  within?: Maybe<Scalars['Float']>;
}

export interface SavedSearchQueryBehaviors {
  __typename?: 'SavedSearchQueryBehaviors';
  good_with_children?: Maybe<Scalars['String']>;
  good_with_dogs?: Maybe<Scalars['String']>;
  good_with_cats?: Maybe<Scalars['String']>;
  good_with_other_animals?: Maybe<Scalars['String']>;
}

export interface AuthenticationToken {
  __typename?: 'AuthenticationToken';
  token: Scalars['String'];
  data: TokenData;
}

export interface TokenData {
  __typename?: 'TokenData';
  sub: Scalars['String'];
  name: Scalars['String'];
  legacyUserId: Scalars['Int'];
  clientId: Scalars['String'];
  email: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']>>;
  organizations?: Maybe<Array<TokenOrganization>>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  expiresTTL: Scalars['Int'];
}

export interface TokenOrganization {
  __typename?: 'TokenOrganization';
  legacyOrganizationId: Scalars['Int'];
  displayId: Scalars['String'];
  role: Role;
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Authenticate with client credentials and return a Petfinder API token */
  authenticateWithClientCredentials: ClientSessionPayload;
  /** Authenticate with a Firebase token and return a Petfinder API token */
  authenticateWithFirebase: FirebaseSessionPayload;
  /** Authenticate with a cookie and return a Petfinder API token */
  authenticateWithCookie: UserSessionPayload;
  /** Authenticate with a username and password and return a Petfinder API token */
  authenticateWithPassword: UserSessionPayload;
  /** Authenticate with a refresh token and return a Petfinder API token */
  authenticateWithRefreshToken: UserSessionPayload;
  /** Authenticate a guest user via client credentials */
  authenticateWithGuest: GuestSessionPayload;
  /** Invalidate the logged in auth, preventing any other requests from being made with it. */
  logout: Scalars['Boolean'];
  /**
   * Register a new user
   *
   * Additionally, the user is authenticated and their session is returned.
   *
   * WARNING: Only the PETFINDER and PURINA SubscriptionChannel's are supported for email subscriptions. Supply any other channels will result in an error.
   */
  registerUser: RegisterUserPayload;
  deleteAnimal: SourceAnimal;
  editAnimal: EditAnimalResponse;
  /** contactId and locationId are required when initializing an animal against platform API */
  initializeAnimal: SourceAnimal;
  favoriteAnimals: FavoriteResult;
  unfavoriteAnimals: FavoriteResult;
  addAnimalAdoptionInquiry?: Maybe<AddAnimalAdoptionInquiryPayload>;
  /** @deprecated Use Animal.attachMedia instead. */
  attachMedia: AttachMediaResponse;
  /** @deprecated Use Animal.deleteAttachments instead. */
  deleteAttachments: Array<MediaDeleteResponse>;
  /** @deprecated Use Animal.deleteAttachments instead. */
  deletePhoto: Array<MediaDeleteResponse>;
  finalizeUpload: UploadResponse;
  initializeUpload: InitializedUploadResponse;
  cloneMedia: MediaInfo;
  cropMedia: MediaInfo;
  rotateMedia: MediaInfo;
  editOrganization: SourceOrganization;
  memberSuccess: MemberSuccessResponse;
  verifyOrganization: VerifyOrganizationResponse;
  /** Update properties of the current user */
  updateUser: User;
  /**
   * Update the current user's email subscriptions
   *
   * This will only change the subscriptions given. Any other subscriptions will not be changed.
   * All user's subscriptions will be returned.
   *
   * WARNING: This mutation will fail if the user was registered within ~5 minutes. It is a known issue in core-api.
   */
  updateEmailSubscriptions: Array<EmailSubscription>;
}


export interface MutationAuthenticateWithClientCredentialsArgs {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  scope?: Array<Scalars['String']>;
}


export interface MutationAuthenticateWithFirebaseArgs {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  scope?: Array<Scalars['String']>;
  token: Scalars['String'];
}


export interface MutationAuthenticateWithPasswordArgs {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  scope?: Array<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}


export interface MutationAuthenticateWithRefreshTokenArgs {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  refreshToken?: InputMaybe<Scalars['String']>;
}


export interface MutationAuthenticateWithGuestArgs {
  guestID: Scalars['ID'];
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  scope?: Array<Scalars['String']>;
}


export interface MutationRegisterUserArgs {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  scope: Array<Scalars['String']>;
  input: RegisterUserInput;
}


export interface MutationDeleteAnimalArgs {
  animalId: Scalars['ID'];
}


export interface MutationEditAnimalArgs {
  animal: AnimalInput;
}


export interface MutationInitializeAnimalArgs {
  orgId: Scalars['ID'];
  typeId: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
}


export interface MutationFavoriteAnimalsArgs {
  ids: Array<Scalars['ID']>;
}


export interface MutationUnfavoriteAnimalsArgs {
  ids: Array<Scalars['ID']>;
}


export interface MutationAddAnimalAdoptionInquiryArgs {
  input: AddAnimalAdoptionInquiryInput;
}


export interface MutationAttachMediaArgs {
  input?: InputMaybe<AttachMediaAnimalInput>;
}


export interface MutationDeleteAttachmentsArgs {
  inputs: Array<DeleteAnimalAttachmentInput>;
}


export interface MutationDeletePhotoArgs {
  animalId: Scalars['ID'];
  attachmentIds: Array<Scalars['String']>;
}


export interface MutationFinalizeUploadArgs {
  input: FinalizeUploadInput;
}


export interface MutationInitializeUploadArgs {
  input: InitializeUploadInput;
}


export interface MutationCloneMediaArgs {
  mediaId: Scalars['ID'];
}


export interface MutationCropMediaArgs {
  input: CropMediaInput;
}


export interface MutationRotateMediaArgs {
  input: RotateMediaInput;
}


export interface MutationEditOrganizationArgs {
  input?: InputMaybe<OrganizationEditInput>;
}


export interface MutationMemberSuccessArgs {
  input: MemberSuccessInput;
}


export interface MutationVerifyOrganizationArgs {
  orgId?: InputMaybe<Scalars['ID']>;
}


export interface MutationUpdateUserArgs {
  changes: UpdateUserInput;
}


export interface MutationUpdateEmailSubscriptionsArgs {
  subscriptions?: InputMaybe<Array<EmailSubscriptionInput>>;
}

export interface ClientSessionPayload {
  __typename?: 'ClientSessionPayload';
  accessToken: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['Int']>;
}

export interface FirebaseSessionPayload {
  __typename?: 'FirebaseSessionPayload';
  accessToken: Scalars['String'];
  userID: Scalars['String'];
  expiresIn?: Maybe<Scalars['Int']>;
  missingProfileRequirements: Array<MissingProfileRequirement>;
}

export enum MissingProfileRequirement {
  /** The user's `address.country` field is blank. */
  MISSING_COUNTRY = 'MISSING_COUNTRY',
  /** The user's `address.postalCode` field is blank. */
  MISSING_POSTAL_CODE = 'MISSING_POSTAL_CODE'
}

export interface UserSessionPayload {
  __typename?: 'UserSessionPayload';
  accessToken: Scalars['String'];
  userID: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['Int']>;
  missingProfileRequirements: Array<MissingProfileRequirement>;
}

export interface GuestSessionPayload {
  __typename?: 'GuestSessionPayload';
  guestID: Scalars['ID'];
  accessToken: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['Int']>;
}

export interface RegisterUserInput {
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  postalCode: Scalars['String'];
  country: Scalars['String'];
  emailSubscriptions?: InputMaybe<Array<EmailSubscriptionInput>>;
}

export interface EmailSubscriptionInput {
  channel: SubscriptionChannel;
  active: Scalars['Boolean'];
}

export interface RegisterUserPayload {
  __typename?: 'RegisterUserPayload';
  accessToken: Scalars['String'];
  userID: Scalars['String'];
  siteSession: UserSessionPayload;
  me: User;
}

export interface AnimalInput {
  id: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
  contactId?: InputMaybe<Scalars['ID']>;
  contactLegacyId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  organizationLegacyId?: InputMaybe<Scalars['ID']>;
  typeId: Scalars['ID'];
  speciesId?: InputMaybe<Scalars['ID']>;
  primaryBreedId?: InputMaybe<Scalars['ID']>;
  secondaryBreedId?: InputMaybe<Scalars['ID']>;
  isMixedBreed?: InputMaybe<Scalars['Boolean']>;
  isUnknownBreed?: InputMaybe<Scalars['Boolean']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  tertiaryColor?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  coatLength?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  extendedDescription?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  arrival?: InputMaybe<Scalars['String']>;
  arrivalDate?: InputMaybe<Scalars['Date']>;
  adoptionDate?: InputMaybe<Scalars['Date']>;
  birthDate?: InputMaybe<Scalars['Date']>;
  organizationAnimalId?: InputMaybe<Scalars['String']>;
  primaryPhotoId?: InputMaybe<Scalars['ID']>;
  status: RecordStatus;
  adoptionStatus?: InputMaybe<AdoptionStatus>;
  attributes: AttributesInput;
  specialNeedsNotes?: InputMaybe<Scalars['String']>;
  homeEnvironmentAttributes: EnvironmentInput;
  tags: Array<InputMaybe<Scalars['String']>>;
  adoptionFee?: InputMaybe<Scalars['Float']>;
  adoptionFeeWaived?: InputMaybe<Scalars['Boolean']>;
  displayAdoptionFee?: InputMaybe<Scalars['Boolean']>;
  importUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  importDeletesEnabled?: InputMaybe<Scalars['Boolean']>;
  revision?: InputMaybe<Scalars['ID']>;
}

export type EditAnimalResponse = SourceAnimal | UpstreamError;

export interface FavoriteResult {
  __typename?: 'FavoriteResult';
  me: User;
  errors: Array<FavoriteError>;
}

export interface FavoriteError extends Error {
  __typename?: 'FavoriteError';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  extensions: FavoriteErrorExtension;
}

export interface Error {
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
}

export interface FavoriteErrorExtension {
  __typename?: 'FavoriteErrorExtension';
  id: Scalars['ID'];
}

export interface AddAnimalAdoptionInquiryInput {
  animalId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}

export interface AddAnimalAdoptionInquiryPayload {
  __typename?: 'AddAnimalAdoptionInquiryPayload';
  animalAdoptionInquiry?: Maybe<AnimalAdoptionInquiry>;
  error?: Maybe<AddAnimalAdoptionInquiryError>;
}

export interface AnimalAdoptionInquiry {
  __typename?: 'AnimalAdoptionInquiry';
  id: Scalars['ID'];
}

export interface AddAnimalAdoptionInquiryError extends Error {
  __typename?: 'AddAnimalAdoptionInquiryError';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  animalId?: Maybe<InputValidationError>;
  note?: Maybe<InputValidationError>;
  phone?: Maybe<InputValidationError>;
}

export interface InputValidationError extends Error {
  __typename?: 'InputValidationError';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
}

export interface AttachMediaAnimalInput {
  animalId: Scalars['ID'];
  mediaType: MediaType;
  /** The ID of the media to be attached. Required when mediaType is PHOTO or VIDEO. */
  mediaId?: InputMaybe<Scalars['ID']>;
  /** The embedCode for the video to be embedded. Required when mediaType is EMBED. */
  embedCode?: InputMaybe<Scalars['String']>;
  /** Index of photo to be attached. Only relevant when mediaType is PHOTO. */
  index?: InputMaybe<Scalars['Int']>;
}

export interface DeleteAnimalAttachmentInput {
  animalId: Scalars['ID'];
  attachmentType: MediaType;
  attachmentId: Scalars['ID'];
}

export type MediaDeleteResponse = DeletedAttachmentId | UpstreamError;

export interface FinalizeUploadInput {
  mediaId: Scalars['ID'];
  parts: Array<UploadedPartInput>;
}

export interface UploadedPartInput {
  part: Scalars['Int'];
  etag: Scalars['String'];
}

export type UploadResponse = UploadInfo | UpstreamError;

export interface InitializeUploadInput {
  contentType: MediaUploadContentType;
  contentLength: Scalars['Int'];
}

export enum MediaUploadContentType {
  BMP = 'BMP',
  GIF = 'GIF',
  JPEG = 'JPEG',
  MP4 = 'MP4',
  PNG = 'PNG',
  MOV = 'MOV'
}

export type InitializedUploadResponse = InitializedUpload | UpstreamError;

export interface InitializedUpload {
  __typename?: 'InitializedUpload';
  mediaId: Scalars['ID'];
  parts: Array<UploadPart>;
}

export interface MediaInfo {
  __typename?: 'MediaInfo';
  mediaId: Scalars['ID'];
  url: Scalars['String'];
  contentType: MediaUploadContentType;
  size: Scalars['Int'];
  checksum: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
  isUsed: Scalars['Boolean'];
}

export interface CropMediaInput {
  mediaId: Scalars['ID'];
  upperLeftX: Scalars['Int'];
  upperLeftY: Scalars['Int'];
  width: Scalars['Int'];
  height: Scalars['Int'];
}

export interface RotateMediaInput {
  mediaId: Scalars['ID'];
  degrees: Scalars['Int'];
}

export interface OrganizationEditInput {
  organizationId: Scalars['ID'];
  name: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  /** Required if 'type' is 'Other' */
  otherTypeDetail?: InputMaybe<Scalars['String']>;
  directorName?: InputMaybe<Scalars['String']>;
  ein?: InputMaybe<Scalars['String']>;
  primaryLocationId?: InputMaybe<Scalars['ID']>;
  primaryContactId?: InputMaybe<Scalars['ID']>;
  primaryPhotoId?: InputMaybe<Scalars['ID']>;
  mailingAddress?: InputMaybe<AddressInput>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  customUrlAlias?: InputMaybe<Scalars['String']>;
  missionStatement?: InputMaybe<Scalars['String']>;
  adoptionPolicies?: InputMaybe<Scalars['String']>;
  locked: Scalars['Boolean'];
  lockedReason?: InputMaybe<Scalars['String']>;
  deactivated: Scalars['Boolean'];
  deactivationReason?: InputMaybe<Scalars['String']>;
  apiExport: Scalars['Boolean'];
  partnerExport: Scalars['Boolean'];
  socialMedia?: InputMaybe<SocialMediaInput>;
  adoptionApplicationUrl?: InputMaybe<Scalars['String']>;
  isMapHidden?: InputMaybe<Scalars['Boolean']>;
  revision?: InputMaybe<Scalars['ID']>;
}

export interface SocialMediaInput {
  twitterUrl?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  pinterestUrl?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  other?: InputMaybe<Scalars['String']>;
}

export interface MemberSuccessInput {
  displayId: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  websiteUrl: Scalars['String'];
  type: Scalars['String'];
  hoursMonday: Scalars['String'];
  hoursTuesday: Scalars['String'];
  hoursWednesday: Scalars['String'];
  hoursThursday: Scalars['String'];
  hoursFriday: Scalars['String'];
  hoursSaturday: Scalars['String'];
  hoursSunday: Scalars['String'];
  socialMediaFacebook?: InputMaybe<Scalars['String']>;
  socialMediaTwitter?: InputMaybe<Scalars['String']>;
  socialMediaInstagram?: InputMaybe<Scalars['String']>;
  socialMediaOther?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  animalTypes: Array<Scalars['String']>;
  specialNeeds?: InputMaybe<Array<Scalars['String']>>;
  adoptionFeeMin: Scalars['Float'];
  adoptionFeeMax: Scalars['Float'];
  spayNeuter: Scalars['String'];
  medicalCare: Scalars['String'];
  missionStatement: Scalars['String'];
  adoptionPolicies?: InputMaybe<Scalars['String']>;
  adoptionApplicationLink: Scalars['String'];
  employeeCount: Scalars['Int'];
  volunteerCount: Scalars['Int'];
  fosterCount: Scalars['Int'];
  annualIntake: Scalars['Int'];
  annualAdoptions: Scalars['Int'];
  annualPetsInFoster: Scalars['Int'];
  rehomeProgram: Scalars['String'];
  onsiteVet: Scalars['String'];
  otherPlatforms?: InputMaybe<Array<Scalars['String']>>;
  otherPlatformsFreeResponse?: InputMaybe<Scalars['String']>;
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  postcode: Scalars['String'];
  mailingAddress1?: InputMaybe<Scalars['String']>;
  mailingAddress2?: InputMaybe<Scalars['String']>;
  mailingCity?: InputMaybe<Scalars['String']>;
  mailingState?: InputMaybe<Scalars['String']>;
  mailingCountry?: InputMaybe<Scalars['String']>;
  mailingPostcode?: InputMaybe<Scalars['String']>;
  pcId?: InputMaybe<Scalars['ID']>;
  pcFirstName: Scalars['String'];
  pcLastName: Scalars['String'];
  pcAddress1: Scalars['String'];
  pcAddress2?: InputMaybe<Scalars['String']>;
  pcCity: Scalars['String'];
  pcState: Scalars['String'];
  pcCountry: Scalars['String'];
  pcPostcode: Scalars['String'];
  pcPhone: Scalars['String'];
  pcEmail: Scalars['String'];
  pcLinkedIn?: InputMaybe<Scalars['String']>;
  pcRole: Scalars['String'];
}

export interface MemberSuccessResponse {
  __typename?: 'MemberSuccessResponse';
  success: Scalars['Boolean'];
  message: Scalars['String'];
}

export interface VerifyOrganizationResponse {
  __typename?: 'VerifyOrganizationResponse';
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
}

export interface UpdateUserInput {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<UserAddressInput>;
  profile?: InputMaybe<UserProfileInput>;
}

export interface UserAddressInput {
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
}

export interface UserProfileInput {
  animalSearchAnimalType?: InputMaybe<AnimalSearchAnimalType>;
  animalSearchCatAnimalAge?: InputMaybe<AnimalSearchAnimalAge>;
  animalSearchCatAnimalBehaviors?: InputMaybe<Array<AnimalSearchCatAnimalBehavior>>;
  /** Deprecated: Use `animalSearchCatAnimalBreeds`. The new field will take precedent over this field if both are present when updating a user. */
  animalSearchCatAnimalBreed?: InputMaybe<Scalars['String']>;
  animalSearchCatAnimalBreeds?: InputMaybe<Array<Scalars['String']>>;
  animalSearchCatAnimalCoatLength?: InputMaybe<AnimalSearchAnimalCoatLength>;
  animalSearchCatAnimalGender?: InputMaybe<AnimalSearchAnimalGender>;
  animalSearchCatAnimalSize?: InputMaybe<AnimalSearchAnimalSize>;
  animalSearchCatAnimalSpecialNeeds?: InputMaybe<AnimalSearchAnimalSpecialNeeds>;
  animalSearchDogAnimalActivityLevel?: InputMaybe<AnimalSearchAnimalActivityLevel>;
  animalSearchDogAnimalAge?: InputMaybe<AnimalSearchAnimalAge>;
  animalSearchDogAnimalBehaviors?: InputMaybe<Array<AnimalSearchDogAnimalBehavior>>;
  /** Deprecated: Use `animalSearchDogAnimalBreeds`. The new field will take precedent over this field if both are present when updating a user. */
  animalSearchDogAnimalBreed?: InputMaybe<Scalars['String']>;
  animalSearchDogAnimalBreeds?: InputMaybe<Array<Scalars['String']>>;
  animalSearchDogAnimalGender?: InputMaybe<AnimalSearchAnimalGender>;
  animalSearchDogAnimalSize?: InputMaybe<AnimalSearchAnimalSize>;
  animalSearchDogAnimalSpecialNeeds?: InputMaybe<AnimalSearchAnimalSpecialNeeds>;
  catsInHome?: InputMaybe<QuantityInHome>;
  dogsInHome?: InputMaybe<QuantityInHome>;
  childrenInHome?: InputMaybe<QuantityInHome>;
  petOwnershipAnimalType?: InputMaybe<PetOwnershipAnimalType>;
  petOwnershipType?: InputMaybe<PetOwnershipType>;
  /** Deprecated: Use `userHomeChildrenChildren` and `userHomeChildrenAge`. The new fields will take precedent over this field if all are present when updating a user. */
  userHomeChildren?: InputMaybe<Array<UserHomeChildren>>;
  userHomeChildrenAge?: InputMaybe<UserHomeChildrenAge>;
  userHomeChildrenChildren?: InputMaybe<UserHomeChildrenChildren>;
  userHomeHoaDogRestrictions?: InputMaybe<UserHomeHoaDogRestrictions>;
  userHomeHoaDogRestrictionsBreeds?: InputMaybe<Array<Scalars['String']>>;
  userHomeHoaDogRestrictionsSize?: InputMaybe<UserHomeHoaDogRestrictionsSize>;
  userHomeNearbyAmenities?: InputMaybe<Array<UserHomeNearbyAmenity>>;
  userHomeType?: InputMaybe<UserHomeType>;
  userHomeYard?: InputMaybe<UserHomeYard>;
}

export type AnimalNodesFragment = { nodes?: Array<{ id: string, adoptionFee?: number | null, adoptionFeeWaived?: boolean | null, age?: string | null, url?: string | null, displayAdoptionFee?: boolean | null, gender?: string | null, name?: string | null, primaryPhotoUrl?: string | null, size?: string | null, species?: string | null, tags: Array<string>, typeName?: string | null, adoptionStatus_?: AdoptionStatus | null, coat?: string | null, breeds: { mixed?: boolean | null, primary?: { name: string } | null, secondary?: { name: string } | null }, colors: { primary?: string | null, secondary?: string | null }, environment: { children?: boolean | null, dogs?: boolean | null, cats?: boolean | null }, organization?: { displayId: string, name: string } | null, publicContact?: { email?: string | null, address: { state: string, postcode: string, city?: string | null } } | null } | { userMatchStrength?: UserAnimalMatchStrength | null, videoEmbed?: string | null, id: string, adoptionFee?: number | null, adoptionFeeWaived?: boolean | null, age?: string | null, url?: string | null, displayAdoptionFee?: boolean | null, gender?: string | null, name?: string | null, primaryPhotoUrl?: string | null, size?: string | null, species?: string | null, tags: Array<string>, typeName?: string | null, adoptionStatus_?: AdoptionStatus | null, coat?: string | null, photos_: Array<{ url?: string | null } | null>, breeds: { mixed?: boolean | null, primary?: { name: string } | null, secondary?: { name: string } | null }, colors: { primary?: string | null, secondary?: string | null }, environment: { children?: boolean | null, dogs?: boolean | null, cats?: boolean | null }, organization?: { displayId: string, name: string } | null, publicContact?: { email?: string | null, address: { state: string, postcode: string, city?: string | null } } | null }> | null };

export type AnimalContactEmailFragment = { nodes?: Array<{ id: string, publicContact?: { email?: string | null } | null } | { id: string, publicContact?: { email?: string | null } | null }> | null };

export type AnimalDataAdoptionInquiryFlowFragment = { nodes?: Array<{ url?: string | null, name?: string | null, primaryPhotoUrl?: string | null, typeName?: string | null } | { url?: string | null, name?: string | null, primaryPhotoUrl?: string | null, typeName?: string | null }> | null };

export type AnimalConnectionQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AnimalConnectionQuery = { animals: { nodes?: Array<{ id: string, adoptionFee?: number | null, adoptionFeeWaived?: boolean | null, age?: string | null, url?: string | null, displayAdoptionFee?: boolean | null, gender?: string | null, name?: string | null, primaryPhotoUrl?: string | null, size?: string | null, species?: string | null, tags: Array<string>, typeName?: string | null, adoptionStatus_?: AdoptionStatus | null, coat?: string | null, breeds: { mixed?: boolean | null, primary?: { name: string } | null, secondary?: { name: string } | null }, colors: { primary?: string | null, secondary?: string | null }, environment: { children?: boolean | null, dogs?: boolean | null, cats?: boolean | null }, organization?: { displayId: string, name: string } | null, publicContact?: { email?: string | null, address: { state: string, postcode: string, city?: string | null } } | null } | { userMatchStrength?: UserAnimalMatchStrength | null, videoEmbed?: string | null, id: string, adoptionFee?: number | null, adoptionFeeWaived?: boolean | null, age?: string | null, url?: string | null, displayAdoptionFee?: boolean | null, gender?: string | null, name?: string | null, primaryPhotoUrl?: string | null, size?: string | null, species?: string | null, tags: Array<string>, typeName?: string | null, adoptionStatus_?: AdoptionStatus | null, coat?: string | null, photos_: Array<{ url?: string | null } | null>, breeds: { mixed?: boolean | null, primary?: { name: string } | null, secondary?: { name: string } | null }, colors: { primary?: string | null, secondary?: string | null }, environment: { children?: boolean | null, dogs?: boolean | null, cats?: boolean | null }, organization?: { displayId: string, name: string } | null, publicContact?: { email?: string | null, address: { state: string, postcode: string, city?: string | null } } | null }> | null } };

export type AnimalBreedSlugsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AnimalBreedSlugsQuery = { animals: { nodes?: Array<{ breeds: { primary?: { id: string, slug?: string | null } | null, secondary?: { id: string, slug?: string | null } | null } } | { breeds: { primary?: { id: string, slug?: string | null } | null, secondary?: { id: string, slug?: string | null } | null } }> | null } };

export type PetDetailUrlQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PetDetailUrlQuery = { animals: { nodes?: Array<{ url?: string | null } | { url?: string | null }> | null } };

export type GetAnimalsBySearchModuleQueryVariables = Exact<{
  modules: Array<SearchModule> | SearchModule;
  longitude: Scalars['String'];
  latitude: Scalars['String'];
  organizationDisplayId?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  animalType?: InputMaybe<AnimalSearchAnimalType>;
  excludedAnimalIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  includedAnimalIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  breedNameFilters?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  allowUndercount?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type GetAnimalsBySearchModuleQuery = { getAnimalsBySearchModule: { matchedModule: SearchModule, totalCount: number, callToActionUrl: string, searchResults: Array<{ profileMatchType: MatchType, animal: { id: string, age?: string | null, gender?: string | null, name?: string | null, primaryPhotoUrl?: string | null, typeName?: string | null, url?: string | null, species?: string | null, adoptionStatus_?: AdoptionStatus | null, breeds: { mixed?: boolean | null, primary?: { name: string } | null, secondary?: { name: string } | null }, publicContact?: { address: { city?: string | null, state: string } } | null } | { id: string, age?: string | null, gender?: string | null, name?: string | null, primaryPhotoUrl?: string | null, typeName?: string | null, url?: string | null, species?: string | null, adoptionStatus_?: AdoptionStatus | null, breeds: { mixed?: boolean | null, primary?: { name: string } | null, secondary?: { name: string } | null }, publicContact?: { address: { city?: string | null, state: string } } | null } }> } };

export type SearchSuggestionsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchSuggestionsQuery = { searchSuggestions?: Array<{ animalType: AnimalSearchAnimalType, label: string, score: number, filter?: { gender?: Array<Gender> | null, age?: Array<Age> | null, size?: Array<Size> | null, household?: Array<GoodWith> | null, breed?: Array<{ name: string }> | null, color?: Array<{ name: string }> | null, coatLength?: Array<{ name: string }> | null, species?: { name: string } | null } | null, url: { query?: string | null, path: string } }> | null };

export type GetLocationQueryVariables = Exact<{
  locationSlug?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
}>;


export type GetLocationQuery = { location: { name: string, displayName: string, latitude: number, longitude: number, slug: string } };

export type GetLocationSuggestionsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
}>;


export type GetLocationSuggestionsQuery = { locations: Array<{ name: string, displayName: string, latitude: number, longitude: number, slug: string, state: { code: string } }> };

export type UserAdopterProfileFragment = { profile: { animalSearchAnimalType?: AnimalSearchAnimalType | null, animalSearchCatAnimalAge?: AnimalSearchAnimalAge | null, animalSearchCatAnimalBehaviors?: Array<AnimalSearchCatAnimalBehavior> | null, animalSearchCatAnimalBreeds?: Array<string> | null, animalSearchCatAnimalCoatLength?: AnimalSearchAnimalCoatLength | null, animalSearchCatAnimalGender?: AnimalSearchAnimalGender | null, animalSearchCatAnimalSize?: AnimalSearchAnimalSize | null, animalSearchCatAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, animalSearchDogAnimalActivityLevel?: AnimalSearchAnimalActivityLevel | null, animalSearchDogAnimalAge?: AnimalSearchAnimalAge | null, animalSearchDogAnimalBehaviors?: Array<AnimalSearchDogAnimalBehavior> | null, animalSearchDogAnimalBreeds?: Array<string> | null, animalSearchDogAnimalGender?: AnimalSearchAnimalGender | null, animalSearchDogAnimalSize?: AnimalSearchAnimalSize | null, animalSearchDogAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, dogsInHome?: QuantityInHome | null, catsInHome?: QuantityInHome | null, childrenInHome?: QuantityInHome | null, petOwnershipAnimalType?: PetOwnershipAnimalType | null, petOwnershipType?: PetOwnershipType | null, userHomeChildrenChildren?: UserHomeChildrenChildren | null, userHomeChildrenAge?: UserHomeChildrenAge | null, userHomeHoaDogRestrictions?: UserHomeHoaDogRestrictions | null, userHomeHoaDogRestrictionsBreeds?: Array<string> | null, userHomeHoaDogRestrictionsSize?: UserHomeHoaDogRestrictionsSize | null, userHomeNearbyAmenities?: Array<UserHomeNearbyAmenity> | null, userHomeType?: UserHomeType | null, userHomeYard?: UserHomeYard | null } };

export type UserFavoritesFragment = { favorites: { nodes?: Array<{ id: string }> | null } };

export type UserAboutMeFragment = { id: string, firstName?: string | null, lastName?: string | null, phone?: string | null, address: { postalCode: string, country: string, state?: string | null } };

export type UserSavedSearchesFragment = { savedSearches?: Array<{ id: string, name: string, type?: AnimalTypeEnum | null, query: { ages?: Array<string> | null, attributes?: Array<string> | null, breed_ids?: Array<string> | null, coat_lengths?: Array<string> | null, colors?: Array<string> | null, name?: string | null, organization_display_ids?: Array<string> | null, published_after?: number | null, sexes?: Array<string> | null, sizes?: Array<string> | null, species_id?: number | null, behaviors?: { good_with_children?: string | null, good_with_dogs?: string | null, good_with_cats?: string | null, good_with_other_animals?: string | null } | null } }> | null };

export type UserEmailFragment = { email: string };

export type UpdateUserMutationVariables = Exact<{
  changes: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, firstName?: string | null, lastName?: string | null, phone?: string | null, address: { postalCode: string, country: string, state?: string | null }, profile: { animalSearchAnimalType?: AnimalSearchAnimalType | null, animalSearchCatAnimalAge?: AnimalSearchAnimalAge | null, animalSearchCatAnimalBehaviors?: Array<AnimalSearchCatAnimalBehavior> | null, animalSearchCatAnimalBreeds?: Array<string> | null, animalSearchCatAnimalCoatLength?: AnimalSearchAnimalCoatLength | null, animalSearchCatAnimalGender?: AnimalSearchAnimalGender | null, animalSearchCatAnimalSize?: AnimalSearchAnimalSize | null, animalSearchCatAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, animalSearchDogAnimalActivityLevel?: AnimalSearchAnimalActivityLevel | null, animalSearchDogAnimalAge?: AnimalSearchAnimalAge | null, animalSearchDogAnimalBehaviors?: Array<AnimalSearchDogAnimalBehavior> | null, animalSearchDogAnimalBreeds?: Array<string> | null, animalSearchDogAnimalGender?: AnimalSearchAnimalGender | null, animalSearchDogAnimalSize?: AnimalSearchAnimalSize | null, animalSearchDogAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, dogsInHome?: QuantityInHome | null, catsInHome?: QuantityInHome | null, childrenInHome?: QuantityInHome | null, petOwnershipAnimalType?: PetOwnershipAnimalType | null, petOwnershipType?: PetOwnershipType | null, userHomeChildrenChildren?: UserHomeChildrenChildren | null, userHomeChildrenAge?: UserHomeChildrenAge | null, userHomeHoaDogRestrictions?: UserHomeHoaDogRestrictions | null, userHomeHoaDogRestrictionsBreeds?: Array<string> | null, userHomeHoaDogRestrictionsSize?: UserHomeHoaDogRestrictionsSize | null, userHomeNearbyAmenities?: Array<UserHomeNearbyAmenity> | null, userHomeType?: UserHomeType | null, userHomeYard?: UserHomeYard | null } } };

export type FavoriteAnimalsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FavoriteAnimalsMutation = { favoriteAnimals: { me: { id: string, favorites: { nodes?: Array<{ id: string }> | null } } } };

export type UnfavoriteAnimalsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UnfavoriteAnimalsMutation = { unfavoriteAnimals: { me: { id: string, favorites: { nodes?: Array<{ id: string }> | null } } } };

export type AddAnimalAdoptionInquiryMutationVariables = Exact<{
  animalId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type AddAnimalAdoptionInquiryMutation = { addAnimalAdoptionInquiry?: { animalAdoptionInquiry?: { id: string } | null, error?: { code: string, message?: string | null, animalId?: { code: string, message?: string | null } | null, note?: { code: string, message?: string | null } | null, phone?: { code: string, message?: string | null } | null } | null } | null };

export type SavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedSearchesQuery = { me?: { savedSearches?: Array<{ id: string, name: string, type?: AnimalTypeEnum | null }> | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, phone?: string | null, address: { postalCode: string, country: string, state?: string | null }, profile: { animalSearchAnimalType?: AnimalSearchAnimalType | null, animalSearchCatAnimalAge?: AnimalSearchAnimalAge | null, animalSearchCatAnimalBehaviors?: Array<AnimalSearchCatAnimalBehavior> | null, animalSearchCatAnimalBreeds?: Array<string> | null, animalSearchCatAnimalCoatLength?: AnimalSearchAnimalCoatLength | null, animalSearchCatAnimalGender?: AnimalSearchAnimalGender | null, animalSearchCatAnimalSize?: AnimalSearchAnimalSize | null, animalSearchCatAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, animalSearchDogAnimalActivityLevel?: AnimalSearchAnimalActivityLevel | null, animalSearchDogAnimalAge?: AnimalSearchAnimalAge | null, animalSearchDogAnimalBehaviors?: Array<AnimalSearchDogAnimalBehavior> | null, animalSearchDogAnimalBreeds?: Array<string> | null, animalSearchDogAnimalGender?: AnimalSearchAnimalGender | null, animalSearchDogAnimalSize?: AnimalSearchAnimalSize | null, animalSearchDogAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, dogsInHome?: QuantityInHome | null, catsInHome?: QuantityInHome | null, childrenInHome?: QuantityInHome | null, petOwnershipAnimalType?: PetOwnershipAnimalType | null, petOwnershipType?: PetOwnershipType | null, userHomeChildrenChildren?: UserHomeChildrenChildren | null, userHomeChildrenAge?: UserHomeChildrenAge | null, userHomeHoaDogRestrictions?: UserHomeHoaDogRestrictions | null, userHomeHoaDogRestrictionsBreeds?: Array<string> | null, userHomeHoaDogRestrictionsSize?: UserHomeHoaDogRestrictionsSize | null, userHomeNearbyAmenities?: Array<UserHomeNearbyAmenity> | null, userHomeType?: UserHomeType | null, userHomeYard?: UserHomeYard | null }, savedSearches?: Array<{ id: string, name: string, type?: AnimalTypeEnum | null, query: { ages?: Array<string> | null, attributes?: Array<string> | null, breed_ids?: Array<string> | null, coat_lengths?: Array<string> | null, colors?: Array<string> | null, name?: string | null, organization_display_ids?: Array<string> | null, published_after?: number | null, sexes?: Array<string> | null, sizes?: Array<string> | null, species_id?: number | null, behaviors?: { good_with_children?: string | null, good_with_dogs?: string | null, good_with_cats?: string | null, good_with_other_animals?: string | null } | null } }> | null } | null };

export type UserWithFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserWithFavoritesQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, phone?: string | null, address: { postalCode: string, country: string, state?: string | null }, profile: { animalSearchAnimalType?: AnimalSearchAnimalType | null, animalSearchCatAnimalAge?: AnimalSearchAnimalAge | null, animalSearchCatAnimalBehaviors?: Array<AnimalSearchCatAnimalBehavior> | null, animalSearchCatAnimalBreeds?: Array<string> | null, animalSearchCatAnimalCoatLength?: AnimalSearchAnimalCoatLength | null, animalSearchCatAnimalGender?: AnimalSearchAnimalGender | null, animalSearchCatAnimalSize?: AnimalSearchAnimalSize | null, animalSearchCatAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, animalSearchDogAnimalActivityLevel?: AnimalSearchAnimalActivityLevel | null, animalSearchDogAnimalAge?: AnimalSearchAnimalAge | null, animalSearchDogAnimalBehaviors?: Array<AnimalSearchDogAnimalBehavior> | null, animalSearchDogAnimalBreeds?: Array<string> | null, animalSearchDogAnimalGender?: AnimalSearchAnimalGender | null, animalSearchDogAnimalSize?: AnimalSearchAnimalSize | null, animalSearchDogAnimalSpecialNeeds?: AnimalSearchAnimalSpecialNeeds | null, dogsInHome?: QuantityInHome | null, catsInHome?: QuantityInHome | null, childrenInHome?: QuantityInHome | null, petOwnershipAnimalType?: PetOwnershipAnimalType | null, petOwnershipType?: PetOwnershipType | null, userHomeChildrenChildren?: UserHomeChildrenChildren | null, userHomeChildrenAge?: UserHomeChildrenAge | null, userHomeHoaDogRestrictions?: UserHomeHoaDogRestrictions | null, userHomeHoaDogRestrictionsBreeds?: Array<string> | null, userHomeHoaDogRestrictionsSize?: UserHomeHoaDogRestrictionsSize | null, userHomeNearbyAmenities?: Array<UserHomeNearbyAmenity> | null, userHomeType?: UserHomeType | null, userHomeYard?: UserHomeYard | null }, favorites: { nodes?: Array<{ id: string }> | null } } | null };

export const AnimalNodesFragmentDoc = gql`
    fragment AnimalNodes on AnimalConnection {
  nodes {
    id
    adoptionFee
    adoptionFeeWaived
    age
    url
    breeds {
      primary {
        name
      }
      secondary {
        name
      }
      mixed
    }
    colors {
      primary
      secondary
    }
    displayAdoptionFee
    environment {
      children
      dogs
      cats
    }
    gender
    name
    organization {
      displayId
      name
    }
    primaryPhotoUrl
    ... on IndexedAnimal {
      userMatchStrength
      photos_ {
        url
      }
      videoEmbed
    }
    publicContact {
      address {
        state
        postcode
        city
      }
      email
    }
    size
    species
    tags
    typeName
    adoptionStatus_
    coat
  }
}
    `;
export const AnimalContactEmailFragmentDoc = gql`
    fragment AnimalContactEmail on AnimalConnection {
  nodes {
    id
    publicContact {
      email
    }
  }
}
    `;
export const AnimalDataAdoptionInquiryFlowFragmentDoc = gql`
    fragment AnimalDataAdoptionInquiryFlow on AnimalConnection {
  nodes {
    url
    name
    primaryPhotoUrl
    typeName
  }
}
    `;
export const UserAdopterProfileFragmentDoc = gql`
    fragment UserAdopterProfile on User {
  profile {
    animalSearchAnimalType
    animalSearchCatAnimalAge
    animalSearchCatAnimalBehaviors
    animalSearchCatAnimalBreeds
    animalSearchCatAnimalCoatLength
    animalSearchCatAnimalGender
    animalSearchCatAnimalSize
    animalSearchCatAnimalSpecialNeeds
    animalSearchDogAnimalActivityLevel
    animalSearchDogAnimalAge
    animalSearchDogAnimalBehaviors
    animalSearchDogAnimalBreeds
    animalSearchDogAnimalGender
    animalSearchDogAnimalSize
    animalSearchDogAnimalSpecialNeeds
    dogsInHome
    catsInHome
    childrenInHome
    petOwnershipAnimalType
    petOwnershipType
    userHomeChildrenChildren
    userHomeChildrenAge
    userHomeHoaDogRestrictions
    userHomeHoaDogRestrictionsBreeds
    userHomeHoaDogRestrictionsSize
    userHomeNearbyAmenities
    userHomeType
    userHomeYard
  }
}
    `;
export const UserFavoritesFragmentDoc = gql`
    fragment UserFavorites on User {
  favorites(first: 200) {
    nodes {
      id
    }
  }
}
    `;
export const UserAboutMeFragmentDoc = gql`
    fragment UserAboutMe on User {
  id
  firstName
  lastName
  phone
  address {
    postalCode
    country
    state
  }
}
    `;
export const UserSavedSearchesFragmentDoc = gql`
    fragment UserSavedSearches on User {
  savedSearches(sort: CREATED, sortOrder: DESC) {
    id
    name
    type
    query {
      ages
      attributes
      behaviors {
        good_with_children
        good_with_dogs
        good_with_cats
        good_with_other_animals
      }
      breed_ids
      coat_lengths
      colors
      name
      organization_display_ids
      published_after
      sexes
      sizes
      species_id
    }
  }
}
    `;
export const UserEmailFragmentDoc = gql`
    fragment UserEmail on User {
  email
}
    `;
export const AnimalConnectionDocument = gql`
    query AnimalConnection($ids: [ID!]!) {
  animals(ids: $ids) {
    ...AnimalNodes
  }
}
    ${AnimalNodesFragmentDoc}`;

/**
 * __useAnimalConnectionQuery__
 *
 * To run a query within a React component, call `useAnimalConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalConnectionQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAnimalConnectionQuery(baseOptions: Apollo.QueryHookOptions<AnimalConnectionQuery, AnimalConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalConnectionQuery, AnimalConnectionQueryVariables>(AnimalConnectionDocument, options);
      }
export function useAnimalConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalConnectionQuery, AnimalConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalConnectionQuery, AnimalConnectionQueryVariables>(AnimalConnectionDocument, options);
        }
export type AnimalConnectionQueryHookResult = ReturnType<typeof useAnimalConnectionQuery>;
export type AnimalConnectionLazyQueryHookResult = ReturnType<typeof useAnimalConnectionLazyQuery>;
export type AnimalConnectionQueryResult = Apollo.QueryResult<AnimalConnectionQuery, AnimalConnectionQueryVariables>;
export const AnimalBreedSlugsDocument = gql`
    query AnimalBreedSlugs($ids: [ID!]!) {
  animals(ids: $ids) {
    nodes {
      breeds {
        primary {
          id
          slug
        }
        secondary {
          id
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useAnimalBreedSlugsQuery__
 *
 * To run a query within a React component, call `useAnimalBreedSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnimalBreedSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnimalBreedSlugsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAnimalBreedSlugsQuery(baseOptions: Apollo.QueryHookOptions<AnimalBreedSlugsQuery, AnimalBreedSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnimalBreedSlugsQuery, AnimalBreedSlugsQueryVariables>(AnimalBreedSlugsDocument, options);
      }
export function useAnimalBreedSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnimalBreedSlugsQuery, AnimalBreedSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnimalBreedSlugsQuery, AnimalBreedSlugsQueryVariables>(AnimalBreedSlugsDocument, options);
        }
export type AnimalBreedSlugsQueryHookResult = ReturnType<typeof useAnimalBreedSlugsQuery>;
export type AnimalBreedSlugsLazyQueryHookResult = ReturnType<typeof useAnimalBreedSlugsLazyQuery>;
export type AnimalBreedSlugsQueryResult = Apollo.QueryResult<AnimalBreedSlugsQuery, AnimalBreedSlugsQueryVariables>;
export const PetDetailUrlDocument = gql`
    query PetDetailUrl($ids: [ID!]!) {
  animals(ids: $ids) {
    nodes {
      url
    }
  }
}
    `;

/**
 * __usePetDetailUrlQuery__
 *
 * To run a query within a React component, call `usePetDetailUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetDetailUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetDetailUrlQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePetDetailUrlQuery(baseOptions: Apollo.QueryHookOptions<PetDetailUrlQuery, PetDetailUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PetDetailUrlQuery, PetDetailUrlQueryVariables>(PetDetailUrlDocument, options);
      }
export function usePetDetailUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PetDetailUrlQuery, PetDetailUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PetDetailUrlQuery, PetDetailUrlQueryVariables>(PetDetailUrlDocument, options);
        }
export type PetDetailUrlQueryHookResult = ReturnType<typeof usePetDetailUrlQuery>;
export type PetDetailUrlLazyQueryHookResult = ReturnType<typeof usePetDetailUrlLazyQuery>;
export type PetDetailUrlQueryResult = Apollo.QueryResult<PetDetailUrlQuery, PetDetailUrlQueryVariables>;
export const GetAnimalsBySearchModuleDocument = gql`
    query GetAnimalsBySearchModule($modules: [SearchModule!]!, $longitude: String!, $latitude: String!, $organizationDisplayId: String, $count: Int = 8, $animalType: AnimalSearchAnimalType, $excludedAnimalIds: [Int!], $includedAnimalIds: [Int!], $breedNameFilters: [String!], $allowUndercount: Boolean, $pageSize: Int) {
  getAnimalsBySearchModule(
    count: $count
    latitude: $latitude
    longitude: $longitude
    modules: $modules
    organizationDisplayId: $organizationDisplayId
    excludedAnimalIds: $excludedAnimalIds
    includedAnimalIds: $includedAnimalIds
    animalType: $animalType
    breedNameFilters: $breedNameFilters
    allowUndercount: $allowUndercount
    pageSize: $pageSize
  ) {
    matchedModule
    totalCount
    callToActionUrl
    searchResults {
      profileMatchType
      animal {
        id
        age
        gender
        name
        primaryPhotoUrl
        typeName
        url
        breeds {
          primary {
            name
          }
          secondary {
            name
          }
          mixed
        }
        publicContact {
          address {
            city
            state
          }
        }
        species
        adoptionStatus_
      }
    }
  }
}
    `;

/**
 * __useGetAnimalsBySearchModuleQuery__
 *
 * To run a query within a React component, call `useGetAnimalsBySearchModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalsBySearchModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalsBySearchModuleQuery({
 *   variables: {
 *      modules: // value for 'modules'
 *      longitude: // value for 'longitude'
 *      latitude: // value for 'latitude'
 *      organizationDisplayId: // value for 'organizationDisplayId'
 *      count: // value for 'count'
 *      animalType: // value for 'animalType'
 *      excludedAnimalIds: // value for 'excludedAnimalIds'
 *      includedAnimalIds: // value for 'includedAnimalIds'
 *      breedNameFilters: // value for 'breedNameFilters'
 *      allowUndercount: // value for 'allowUndercount'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAnimalsBySearchModuleQuery(baseOptions: Apollo.QueryHookOptions<GetAnimalsBySearchModuleQuery, GetAnimalsBySearchModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnimalsBySearchModuleQuery, GetAnimalsBySearchModuleQueryVariables>(GetAnimalsBySearchModuleDocument, options);
      }
export function useGetAnimalsBySearchModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnimalsBySearchModuleQuery, GetAnimalsBySearchModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnimalsBySearchModuleQuery, GetAnimalsBySearchModuleQueryVariables>(GetAnimalsBySearchModuleDocument, options);
        }
export type GetAnimalsBySearchModuleQueryHookResult = ReturnType<typeof useGetAnimalsBySearchModuleQuery>;
export type GetAnimalsBySearchModuleLazyQueryHookResult = ReturnType<typeof useGetAnimalsBySearchModuleLazyQuery>;
export type GetAnimalsBySearchModuleQueryResult = Apollo.QueryResult<GetAnimalsBySearchModuleQuery, GetAnimalsBySearchModuleQueryVariables>;
export const SearchSuggestionsDocument = gql`
    query SearchSuggestions($query: String!) {
  searchSuggestions(input: {query: $query}) {
    animalType
    label
    score
    filter {
      gender
      age
      size
      breed {
        name
      }
      color {
        name
      }
      coatLength {
        name
      }
      household
      species {
        name
      }
    }
    url {
      query
      path
    }
  }
}
    `;

/**
 * __useSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, options);
      }
export function useSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>(SearchSuggestionsDocument, options);
        }
export type SearchSuggestionsQueryHookResult = ReturnType<typeof useSearchSuggestionsQuery>;
export type SearchSuggestionsLazyQueryHookResult = ReturnType<typeof useSearchSuggestionsLazyQuery>;
export type SearchSuggestionsQueryResult = Apollo.QueryResult<SearchSuggestionsQuery, SearchSuggestionsQueryVariables>;
export const GetLocationDocument = gql`
    query GetLocation($locationSlug: String, $latitude: Float, $longitude: Float) {
  location(
    input: {locationSlug: $locationSlug, latitude: $latitude, longitude: $longitude}
  ) {
    name
    displayName
    latitude
    longitude
    slug
  }
}
    `;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      locationSlug: // value for 'locationSlug'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export const GetLocationSuggestionsDocument = gql`
    query GetLocationSuggestions($q: String, $latitude: Float, $longitude: Float) {
  locations(q: $q, latitude: $latitude, longitude: $longitude) {
    name
    displayName
    latitude
    longitude
    state {
      code
    }
    slug
  }
}
    `;

/**
 * __useGetLocationSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetLocationSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSuggestionsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useGetLocationSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>(GetLocationSuggestionsDocument, options);
      }
export function useGetLocationSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>(GetLocationSuggestionsDocument, options);
        }
export type GetLocationSuggestionsQueryHookResult = ReturnType<typeof useGetLocationSuggestionsQuery>;
export type GetLocationSuggestionsLazyQueryHookResult = ReturnType<typeof useGetLocationSuggestionsLazyQuery>;
export type GetLocationSuggestionsQueryResult = Apollo.QueryResult<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($changes: UpdateUserInput!) {
  updateUser(changes: $changes) {
    ...UserAboutMe
    ...UserAdopterProfile
  }
}
    ${UserAboutMeFragmentDoc}
${UserAdopterProfileFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const FavoriteAnimalsDocument = gql`
    mutation FavoriteAnimals($ids: [ID!]!) {
  favoriteAnimals(ids: $ids) {
    me {
      id
      ...UserFavorites
    }
  }
}
    ${UserFavoritesFragmentDoc}`;
export type FavoriteAnimalsMutationFn = Apollo.MutationFunction<FavoriteAnimalsMutation, FavoriteAnimalsMutationVariables>;

/**
 * __useFavoriteAnimalsMutation__
 *
 * To run a mutation, you first call `useFavoriteAnimalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriteAnimalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriteAnimalsMutation, { data, loading, error }] = useFavoriteAnimalsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFavoriteAnimalsMutation(baseOptions?: Apollo.MutationHookOptions<FavoriteAnimalsMutation, FavoriteAnimalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavoriteAnimalsMutation, FavoriteAnimalsMutationVariables>(FavoriteAnimalsDocument, options);
      }
export type FavoriteAnimalsMutationHookResult = ReturnType<typeof useFavoriteAnimalsMutation>;
export type FavoriteAnimalsMutationResult = Apollo.MutationResult<FavoriteAnimalsMutation>;
export type FavoriteAnimalsMutationOptions = Apollo.BaseMutationOptions<FavoriteAnimalsMutation, FavoriteAnimalsMutationVariables>;
export const UnfavoriteAnimalsDocument = gql`
    mutation UnfavoriteAnimals($ids: [ID!]!) {
  unfavoriteAnimals(ids: $ids) {
    me {
      id
      ...UserFavorites
    }
  }
}
    ${UserFavoritesFragmentDoc}`;
export type UnfavoriteAnimalsMutationFn = Apollo.MutationFunction<UnfavoriteAnimalsMutation, UnfavoriteAnimalsMutationVariables>;

/**
 * __useUnfavoriteAnimalsMutation__
 *
 * To run a mutation, you first call `useUnfavoriteAnimalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfavoriteAnimalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfavoriteAnimalsMutation, { data, loading, error }] = useUnfavoriteAnimalsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnfavoriteAnimalsMutation(baseOptions?: Apollo.MutationHookOptions<UnfavoriteAnimalsMutation, UnfavoriteAnimalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfavoriteAnimalsMutation, UnfavoriteAnimalsMutationVariables>(UnfavoriteAnimalsDocument, options);
      }
export type UnfavoriteAnimalsMutationHookResult = ReturnType<typeof useUnfavoriteAnimalsMutation>;
export type UnfavoriteAnimalsMutationResult = Apollo.MutationResult<UnfavoriteAnimalsMutation>;
export type UnfavoriteAnimalsMutationOptions = Apollo.BaseMutationOptions<UnfavoriteAnimalsMutation, UnfavoriteAnimalsMutationVariables>;
export const AddAnimalAdoptionInquiryDocument = gql`
    mutation AddAnimalAdoptionInquiry($animalId: ID!, $note: String, $phone: String) {
  addAnimalAdoptionInquiry(
    input: {animalId: $animalId, note: $note, phone: $phone}
  ) {
    animalAdoptionInquiry {
      id
    }
    error {
      code
      message
      animalId {
        code
        message
      }
      note {
        code
        message
      }
      phone {
        code
        message
      }
    }
  }
}
    `;
export type AddAnimalAdoptionInquiryMutationFn = Apollo.MutationFunction<AddAnimalAdoptionInquiryMutation, AddAnimalAdoptionInquiryMutationVariables>;

/**
 * __useAddAnimalAdoptionInquiryMutation__
 *
 * To run a mutation, you first call `useAddAnimalAdoptionInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAnimalAdoptionInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAnimalAdoptionInquiryMutation, { data, loading, error }] = useAddAnimalAdoptionInquiryMutation({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      note: // value for 'note'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useAddAnimalAdoptionInquiryMutation(baseOptions?: Apollo.MutationHookOptions<AddAnimalAdoptionInquiryMutation, AddAnimalAdoptionInquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAnimalAdoptionInquiryMutation, AddAnimalAdoptionInquiryMutationVariables>(AddAnimalAdoptionInquiryDocument, options);
      }
export type AddAnimalAdoptionInquiryMutationHookResult = ReturnType<typeof useAddAnimalAdoptionInquiryMutation>;
export type AddAnimalAdoptionInquiryMutationResult = Apollo.MutationResult<AddAnimalAdoptionInquiryMutation>;
export type AddAnimalAdoptionInquiryMutationOptions = Apollo.BaseMutationOptions<AddAnimalAdoptionInquiryMutation, AddAnimalAdoptionInquiryMutationVariables>;
export const SavedSearchesDocument = gql`
    query SavedSearches {
  me {
    savedSearches(sort: CREATED, sortOrder: DESC) {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useSavedSearchesQuery__
 *
 * To run a query within a React component, call `useSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedSearchesQuery(baseOptions?: Apollo.QueryHookOptions<SavedSearchesQuery, SavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedSearchesQuery, SavedSearchesQueryVariables>(SavedSearchesDocument, options);
      }
export function useSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedSearchesQuery, SavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedSearchesQuery, SavedSearchesQueryVariables>(SavedSearchesDocument, options);
        }
export type SavedSearchesQueryHookResult = ReturnType<typeof useSavedSearchesQuery>;
export type SavedSearchesLazyQueryHookResult = ReturnType<typeof useSavedSearchesLazyQuery>;
export type SavedSearchesQueryResult = Apollo.QueryResult<SavedSearchesQuery, SavedSearchesQueryVariables>;
export const UserDocument = gql`
    query User {
  me {
    ...UserAboutMe
    ...UserAdopterProfile
    ...UserSavedSearches
  }
}
    ${UserAboutMeFragmentDoc}
${UserAdopterProfileFragmentDoc}
${UserSavedSearchesFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserWithFavoritesDocument = gql`
    query UserWithFavorites {
  me {
    ...UserAboutMe
    ...UserAdopterProfile
    ...UserFavorites
  }
}
    ${UserAboutMeFragmentDoc}
${UserAdopterProfileFragmentDoc}
${UserFavoritesFragmentDoc}`;

/**
 * __useUserWithFavoritesQuery__
 *
 * To run a query within a React component, call `useUserWithFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWithFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserWithFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<UserWithFavoritesQuery, UserWithFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWithFavoritesQuery, UserWithFavoritesQueryVariables>(UserWithFavoritesDocument, options);
      }
export function useUserWithFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWithFavoritesQuery, UserWithFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWithFavoritesQuery, UserWithFavoritesQueryVariables>(UserWithFavoritesDocument, options);
        }
export type UserWithFavoritesQueryHookResult = ReturnType<typeof useUserWithFavoritesQuery>;
export type UserWithFavoritesLazyQueryHookResult = ReturnType<typeof useUserWithFavoritesLazyQuery>;
export type UserWithFavoritesQueryResult = Apollo.QueryResult<UserWithFavoritesQuery, UserWithFavoritesQueryVariables>;